import Vue from "vue";
import om from "@/api/index";
import router from "@/router";
import mock from "@/__mocks__/store-mock.js";
import config from "@/config/brands/index";
import getters from "@/store/getters";
import actions from "@/store/actions";
import state from "@/store/state";
import * as ACTIONS from "@/config/constants/action-types";
import * as END_POINTS from "@/config/constants/end-points";
import * as MUTATIONS from "@/config/constants/mutation-types";
import {
  ERROR_TECNICO,
  INDIVIDUO_NEGATIVO,
  ERROR_CONFIRMACION_RENAPER,
  ERROR_SOLICITUD,
  CLIENTE_NO_CENSADO
} from "@/config/constants/step-constants";
import { PCG7 } from "@/config/constants/index";
import {
  processHandleOkStatus,
  processHandleErrorStatus,
  guardarHandleOkStatus
} from "@/utils/domicilios";
import { ERROR_CONEXION } from "@/config/constants/step-constants";
import { agregarACola } from "@/utils/promise-queue";
import {
  caminosBiometria,
  setearCaminosBiometria
} from "@/config/constants/caminosBiometria";
import ASO, { withTsecAuth } from "@/api/aso";
import { retry } from "../../api";

jest.useFakeTimers();

jest.mock("@/router", () => ({
  push: jest.fn(),
  replace: jest.fn()
}));

jest.mock("@/utils/domicilios", () => ({
  processHandleOkStatus: jest.fn(),
  processHandleErrorStatus: jest.fn(),
  setModelDomicilioOption: jest.fn(),
  setRehacerOption: jest.fn(),
  guardarHandleOkStatus: jest.fn()
}));

jest.mock("@/store/getters", () => ({
  getConfirmacionData: () => mock.getters.getConfirmacionData(),
  getConsulta: () => mock.getters.getConsulta(),
  getDataOferta: () => mock.getters.getDataOferta(),
  getDataQuery: () => mock.getters.getDataQuery(),
  getDatosCaEmprendedores: () => mock.getters.getDatosCaEmprendedores(),
  getDatosCaSuelta: () => mock.getters.getDatosCaSuelta(),
  getDatosCGU: () => mock.getters.getDatosCGU(),
  getPaso1: () => mock.getters.getPaso1(),
  getPaso2: () => mock.getters.getPaso2(),
  getPaso3: () => mock.getters.getPaso3(),
  getPaso4: () => mock.getters.getPaso4(),
  getRoute: () => mock.getters.getRoute(),
  getSucursal: () => mock.getters.getSucursal(),
  getTCode: () => mock.getters.getTCode(),
  getDeviceId: () => mock.getters.getDeviceId(),
  getDeviceIdTimestamp: () => mock.getters.getDeviceIdTimestamp(),
  getOferta: () => mock.getters.getOferta(),
  getNumeroCliente: () => mock.getters.getNumeroCliente(),
  getKeyLoginVeridas: () => mock.getters.getKeyLoginVeridas(),
  getConfirmacionDataVeridas: () => mock.getters.getConfirmacionDataVeridas(),
  getContractsPdf: () => mock.getters.getContractsPdf(),
  getNumeroTramite: () => mock.getters.getNumeroTramite(),
  getRandomKey: () => mock.getters.getRandomKey(),
  getDeviceUdid: () => mock.getters.getDeviceUdid(),
  getCelularNormalizado: () => mock.getters.getCelularNormalizado(),
  getDomicilio: tDomic => {
    if (tDomic === "10") {
      return mock.state.domicilioAlternativo;
    }
    return mock.state.domicilio;
  },
  getVeridasId: () => mock.getters.getVeridasId()
}));

jest.mock("@/api/index", () => ({
  request: jest.fn(),
  sucursales: jest.fn(),
  loginVeridas: jest.fn(),
  getResultVeridas: jest.fn(),
  downloadContract: jest.fn(),
  crearUsuario: jest.fn(),
  enviarResultadosBiometria: jest.fn(),
  consultarReintentosBio: jest.fn(),
  enviarEventoDvsFS: jest.fn(),
  validarRiesgoCliente: jest.fn(),
  retry: jest.fn()
}));

jest.mock("@/api/aso", () => ({
  withTsecAuth: jest.fn(),
  getVeridasResult: jest.fn(),
  getRenaperValidation: jest.fn()
}));

jest.mock("@/utils/promise-queue", () => ({
  agregarACola: jest.fn()
}));

jest.mock("@/config/constants/caminosBiometria", () => ({
  caminosBiometria: {},
  setearCaminosBiometria: jest.fn()
}));

describe("store actions", () => {
  let commit;
  let dispatch;
  let push;

  beforeEach(() => {
    commit = jest.fn();
    dispatch = jest.fn();
    push = jest.fn();
    jest.clearAllMocks();
    global._BBVA_MOTOR = "ofertaNomina";
  });

  const payload = {
    name: "test",
    nroDoc: "11222333",
    numeroDoc: "11222333",
    tipoDoc: "00",
    genero: "M",
    nombre: "",
    apellido: "",
    nacionalidad: "80",
    sexo: "F",
    email: "",
    tipoResidencia: "temporal",
    fechaNacimiento: "01/01/1492",
    celular: {
      area: "",
      numero: ""
    },
    captcha: "",
    searchType: "test",
    domicilio: { depto: "dptoTest", codProvincia: "01" },
    cuil: "20-00000000-0",
    expediente: "mockExpediente",
    calleLocalidad: "calleLocalidadTest",
    codigoPostal: "codigoPostalTest"
  };

  it("DO_ROUTE", () => {
    actions[ACTIONS.DO_ROUTE]({ commit }, payload);

    jest.runAllTimers();
    expect(setTimeout).toHaveBeenCalledTimes(1);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_ROUTE, payload);
    expect(setTimeout).toHaveBeenLastCalledWith(expect.any(Function), 0);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
  });

  it("DO_IS_LOADING", () => {
    actions[ACTIONS.DO_IS_LOADING]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, payload);
  });

  it("DO_NOTIFICATION_TOAST", () => {
    actions[ACTIONS.DO_NOTIFICATION_TOAST]({ commit, dispatch }, payload);

    jest.runAllTimers();
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_NOTIFICATION_TOAST,
      payload
    );
    expect(setTimeout).toHaveBeenCalledTimes(1);
    expect(setTimeout).toHaveBeenLastCalledWith(expect.any(Function), 3000);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_NOTIFICATION_TOAST_RESET);
  });

  it("DO_NOTIFICATION_TOAST_RESET", () => {
    actions[ACTIONS.DO_NOTIFICATION_TOAST_RESET](
      { commit, dispatch },
      {
        type: "",
        message: ""
      }
    );

    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_NOTIFICATION_TOAST, {
      type: "",
      message: ""
    });
  });

  it("DO_REQUEST_API", async () => {
    const state = {
      mock: false
    };

    const payload = {
      endPoint: END_POINTS.NOMINAS_CONSULTA,
      payload: {},
      doSuccess: ACTIONS.DO_QUERY_SUCCESS,
      doError: ACTIONS.DO_QUERY_ERROR,
      payloadSuccess: {
        successData: {}
      }
    };

    om.request.mockResolvedValue({
      data: {
        respuesta: ""
      }
    });

    await actions[ACTIONS.DO_REQUEST_API]({ state, dispatch }, payload);

    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_QUERY_SUCCESS, {
      respuesta: "",
      payloadSuccess: {
        successData: {}
      }
    });
  });

  it("DO_FORZAR_DNE", () => {
    actions[ACTIONS.DO_FORZAR_DNE]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_FORZAR_DNE, payload);
  });

  it("DO_LANDING", () => {
    router.push = push;
    actions[ACTIONS.DO_LANDING]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_LANDING, payload);
    expect(push).toHaveBeenCalledWith("consulta");
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ADOBE_APP_ON_CLICK_START,
      payload
    );
  });
  it("DO_CONSULTAR_RENAPER", () => {
    actions[ACTIONS.DO_CONSULTAR_RENAPER](
      { commit, dispatch, getters },
      payload
    );
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_CONFIRMAR_RENAPER,
      payload
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONFIRMAR_RENAPER,
      doSuccess: ACTIONS.DO_CONSULTAR_RENAPER_SUCCESS,
      doError: ACTIONS.DO_CONSULTAR_RENAPER_ERROR,
      payload: {
        nombre: "nombreConsultaTest",
        apellido: "apellidoConsultaTest",
        nroDoc: "99888777",
        tipoDoc: "00",
        nacionalidad: "80",
        sexo: "M",
        fechaNacimiento: "01/01/0476",
        expediente: "mockExpediente"
      }
    });
  });

  it("DO_CONSULTAR_RENAPER_SUCCESS x STATUS OK", () => {
    const payload = {
      status: "OK"
    };
    actions[ACTIONS.DO_CONSULTAR_RENAPER_SUCCESS](
      { dispatch, getters },
      payload
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_QUERY, {
      nombre: "nombreConsultaTest",
      apellido: "apellidoConsultaTest",
      tipoDoc: "00",
      numeroDoc: "99888777",
      nacionalidad: "80",
      sexo: "M",
      email: "",
      tipoResidencia: "",
      fechaNacimiento: "01/01/0476",
      celular: {
        area: "11",
        numero: "28756563",
        normalizado: {
          area: "11",
          caracteristica: "3815",
          nro: "3838",
          interno: "",
          valido: true
        }
      },
      captcha: ""
    });
  });

  it("DO_CONSULTAR_RENAPER_SUCCESS x STATUS ERROR", () => {
    const payload = {
      status: "ERROR"
    };
    actions[ACTIONS.DO_CONSULTAR_RENAPER_SUCCESS](
      { commit, dispatch },
      payload
    );
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_MENSAJE,
      ERROR_CONFIRMACION_RENAPER
    );
  });

  it("DO_CONSULTAR_RENAPER_ERROR", () => {
    actions[ACTIONS.DO_CONSULTAR_RENAPER_ERROR]({ commit, dispatch }, payload);
    expect(Vue.$log.error).toHaveBeenCalledWith(payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  });

  it("DO_PASO_CARRO_ABANDONADO", () => {
    const payload = {
      paso: "paso1"
    };

    const gettersMock = {
      ...getters,
      getOferta: () => ({
        carro: "",
        dictamen: "APROBADO"
      })
    };

    const dataPayload = {
      consulta: {
        ...getters.getConsulta(),
        c: _BBVA_MOTOR + getters.getTCode()
      },
      oferta: gettersMock.getOferta(),
      paso1: getters.getPaso1(),
      paso2: getters.getPaso2(),
      paso3: getters.getPaso3(),
      paso4: getters.getPaso4()
    };

    delete dataPayload.oferta.carro;

    actions[ACTIONS.DO_PASO_CARRO_ABANDONADO](
      { dispatch, getters: gettersMock },
      payload
    );

    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.PERSISTIR_NUEVO_PASO,
      doSuccess: ACTIONS.DO_PASO_CARRO_ABANDONADO_SUCCESS,
      doError: ACTIONS.DO_PASO_CARRO_ABANDONADO_ERROR,
      payload: {
        randomKey: "",
        paso: "paso1",
        datos: JSON.stringify(dataPayload),
        circuito: "nominas"
      }
    });
  });

  it("DO_PASO_CARRO_ABANDONADO dictamen NO-APROBADO", () => {
    const payload = {
      paso: "paso1"
    };

    const gettersMock = {
      ...getters,
      getOferta: () => ({
        carro: "",
        dictamen: "NO-APROBADO"
      })
    };

    const dataPayload = {
      consulta: {
        ...getters.getConsulta(),
        c: _BBVA_MOTOR + getters.getTCode()
      },
      oferta: gettersMock.getOferta(),
      paso1: getters.getPaso1(),
      paso2: getters.getPaso2(),
      paso3: getters.getPaso3(),
      paso4: getters.getPaso4()
    };

    delete dataPayload.oferta.carro;

    actions[ACTIONS.DO_PASO_CARRO_ABANDONADO](
      { dispatch, getters: gettersMock },
      payload
    );

    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.PERSISTIR_NUEVO_PASO,
      doSuccess: ACTIONS.DO_PASO_CARRO_ABANDONADO_SUCCESS,
      doError: ACTIONS.DO_PASO_CARRO_ABANDONADO_ERROR,
      payload: {
        randomKey: "",
        paso: "paso1",
        datos: JSON.stringify(dataPayload),
        circuito: ""
      }
    });
  });

  it("DO_PASO_CARRO_ABANDONADO_SUCCESS", () => {
    const payload = {
      respuesta: {}
    };
    actions[ACTIONS.DO_PASO_CARRO_ABANDONADO_SUCCESS]({}, payload);
    expect(Vue.$log.info).toHaveBeenCalledWith("Paso guardado en CA", {});
  });

  it("DO_PASO_CARRO_ABANDONADO_ERROR", () => {
    const payload = "Error CA";
    actions[ACTIONS.DO_PASO_CARRO_ABANDONADO_ERROR]({}, payload);
    expect(Vue.$log.error).toHaveBeenCalledWith("Error grabando CA: Error CA");
  });

  it("DO_PASO1", () => {
    const payload = {
      cuil: "20-00000111-9"
    };
    router.push = push;
    actions[ACTIONS.DO_PASO1]({ commit, dispatch, getters }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(push).toHaveBeenCalledWith("paso2");
  });

  it("DO_PASO1 x el ELSE", () => {
    const context = {
      commit,
      dispatch,
      getters: {
        getPaso1: () => ({
          domicilioParticular: {
            valido: false
          }
        })
      },
      state: {
        dataOferta: {
          oferta: {
            randomkey: "randomkeyMerlin"
          }
        }
      }
    };
    const payload = {
      cuil: "20-00000111-9",
      domicilioParticular: {
        calle: "calleMerlinPASO1",
        numero: "numeroMerlinPASO1",
        piso: "pisoMerlinPASO1",
        dpto: "dptoMerlinPASO1",
        codigoPostal: "codigoPostalMerlinPASO1",
        localidad: "localidadMerlinPASO1",
        codProvincia: "01"
      }
    };
    actions[ACTIONS.DO_PASO1](context, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.MERLIN,
      doSuccess: ACTIONS.DO_PASO1_SUCCESS,
      doError: ACTIONS.DO_PASO1_ERROR,
      payload: {
        randomKey: "",
        domicilio: {
          calle: "calleMerlinPASO1",
          numero: "numeroMerlinPASO1",
          piso: "pisoMerlinPASO1",
          departamento: "dptoMerlinPASO1",
          codigoPostal: "codigoPostalMerlinPASO1",
          localidad: "localidadMerlinPASO1",
          provincia: "01"
        }
      }
    });
  });

  it("DO_PASO1_SUCCESS with Status Error", () => {
    const payload = {
      status: "ERROR",
      respuesta: {}
    };
    const dataPaso1 = {
      estadoCivil: "5",
      conyuge: {
        nombre: "",
        apellido: "",
        tipoDoc: "00",
        numeroDoc: ""
      },
      lugarNacimiento: "",
      domicilioParticular: {
        calle: "",
        numero: "",
        piso: "",
        dpto: "",
        codigoPostal: "",
        localidad: "",
        codProvincia: "01",
        valido: false,
        searchEncontesa: false
      },
      searchEncontesa: false
    };
    actions[ACTIONS.DO_PASO1_SUCCESS]({ commit, getters }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_PASO_1, dataPaso1);
  });

  it("DO_PASO1_SUCCESS with Status OK", () => {
    const payload = {
      status: "OK",
      respuesta: {
        validMerlin: true,
        domicilio: {
          codProvincia: "01"
        }
      }
    };
    const dataPaso1 = {
      estadoCivil: "5",
      conyuge: {
        nombre: "",
        apellido: "",
        tipoDoc: "00",
        numeroDoc: ""
      },
      lugarNacimiento: "",
      domicilioParticular: {
        calle: "",
        numero: "",
        piso: "",
        dpto: "",
        codigoPostal: "",
        localidad: "",
        codProvincia: "01",
        provincia: "01",
        valido: true,
        searchEncontesa: false
      },
      searchEncontesa: false
    };
    actions[ACTIONS.DO_PASO1_SUCCESS]({ commit, getters, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_PASO_1, dataPaso1);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_PASO_CARRO_ABANDONADO, {
      paso: "paso1"
    });
  });

  it("DO_PASO1_ERROR", () => {
    actions[ACTIONS.DO_PASO1_ERROR]({ commit }, payload);
    expect(Vue.$log.error).toHaveBeenCalledWith(payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
  });

  it("DO_PASO2", () => {
    actions[ACTIONS.DO_PASO2]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_PASO_2, payload);
  });

  it("DO_PASO3", () => {
    actions[ACTIONS.DO_PASO3]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_PASO_3, payload);
  });

  it("DO_PASO3 continuaSucursal", () => {
    const payload = {
      pep: "1",
      sujetoObligado: "1",
      fatca: "1"
    };
    actions[ACTIONS.DO_PASO3]({ commit, dispatch }, payload);
    expect(router.push).toHaveBeenCalledWith({
      name: "continuaSucursal",
      params: { mensaje: "mensaje-1" }
    });
  });

  it("DO_NORMALIZAR_DOMICILIO", () => {
    const payload = {
      payload: {
        valido: true
      },
      selectDomicilio: "otro"
    };
    actions[ACTIONS.DO_NORMALIZAR_DOMICILIO]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_NORMALIZAR_DOMICILIO_ALTE,
      {
        valido: true
      }
    );
  });

  it("DO_NORMALIZAR_DOMICILIO x selectDomicilio PARTICULAR", () => {
    const payload = {
      payload: {
        valido: true
      },
      selectDomicilio: "particular"
    };
    actions[ACTIONS.DO_NORMALIZAR_DOMICILIO]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_NORMALIZAR_DOMICILIO_PART,
      {
        valido: true
      }
    );
  });

  it("DO_NORMALIZAR_DOMICILIO x valido en FALSE", () => {
    const context = {
      commit,
      dispatch,
      state: {
        dataOferta: {
          oferta: {
            randomkey: ""
          }
        }
      }
    };
    const payload = {
      payload: {
        valido: false,
        calle: "calleMerlin",
        numero: "numeroMerlin",
        piso: "pisoMerlin",
        dpto: "dptoMerlin",
        codigoPostal: "codigoPostalMerlin",
        localidad: "localidadMerlin",
        codProvincia: "01"
      },
      selectDomicilio: "particular"
    };
    actions[ACTIONS.DO_NORMALIZAR_DOMICILIO](context, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.MERLIN,
      doSuccess: ACTIONS.DO_NORMALIZAR_DOMICILIO_SUCCESS,
      doError: ACTIONS.DO_NORMALIZAR_DOMICILIO_ERROR,
      payload: {
        randomKey: "",
        domicilio: {
          calle: "calleMerlin",
          numero: "numeroMerlin",
          piso: "pisoMerlin",
          departamento: "dptoMerlin",
          codigoPostal: "codigoPostalMerlin",
          barrio: "",
          localidad: "localidadMerlin",
          provincia: "01"
        }
      },
      payloadSuccess: { selectDomicilio: "particular" }
    });
  });

  it("DO_NORMALIZAR_DOMICILIO_SUCCESS x STATUS ERROR", () => {
    const payload = {
      status: "ERROR",
      respuesta: {
        domicilio: {
          localidad: "00"
        }
      }
    };
    actions[ACTIONS.DO_NORMALIZAR_DOMICILIO_SUCCESS]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_NORMALIZAR_DOMICILIO_PART,
      {
        valido: false,
        localidad: "00",
        searchEncontesa: false
      }
    );
  });

  it("DO_NORMALIZAR_DOMICILIO_SUCCESS x STATUS OK", () => {
    const payload = {
      status: "OK",
      respuesta: {
        domicilio: {
          localidad: "00"
        }
      },
      payloadSuccess: {
        selectDomicilio: "otro"
      }
    };
    actions[ACTIONS.DO_NORMALIZAR_DOMICILIO_SUCCESS]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_NORMALIZAR_DOMICILIO_ALTE,
      {
        valido: false,
        localidad: "00",
        searchEncontesa: false
      }
    );
  });

  it("DO_NORMALIZAR_DOMICILIO_ERROR", () => {
    actions[ACTIONS.DO_NORMALIZAR_DOMICILIO_ERROR]({ commit }, payload);
    expect(Vue.$log.error).toHaveBeenCalledWith(payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
  });

  it("DO_SELECT_PARTICULAR", () => {
    const context = {
      commit,
      state: {
        paso1: {
          estadoCivil: "5",
          conyuge: {
            nombre: "",
            apellido: "",
            tipoDoc: "00",
            numeroDoc: ""
          },
          lugarNacimiento: "",
          domicilioParticular: {
            calle: "",
            numero: "",
            piso: "",
            dpto: "",
            codigoPostal: "",
            localidad: "",
            codProvincia: "01",
            valido: null
          },
          searchEncontesa: false
        },
        paso4: {
          email: "",
          resumenDigital: "mockResumenDigital",
          sucursal: "",
          selectDomicilio: "particular",
          domicilioParticular: {
            calle: "",
            numero: "",
            piso: "",
            dpto: "",
            codigoPostal: "",
            localidad: "",
            codProvincia: "01",
            valido: null
          },
          otroDomicilio: {
            calle: "",
            numero: "",
            piso: "",
            dpto: "",
            codigoPostal: "",
            localidad: "",
            codProvincia: "01",
            valido: null
          },
          searchEncontesa: false
        }
      }
    };
    actions[ACTIONS.DO_SELECT_PARTICULAR](context, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_PASO_1, {
      estadoCivil: "5",
      conyuge: {
        nombre: "",
        apellido: "",
        tipoDoc: "00",
        numeroDoc: ""
      },
      lugarNacimiento: "",
      domicilioParticular: {
        calle: "calleLocalidadTest",
        numero: "",
        piso: "",
        dpto: "",
        codigoPostal: "codigoPostalTest",
        localidad: "",
        codProvincia: "01",
        valido: true,
        searchEncontesa: false,
        lineas: []
      },
      searchEncontesa: false
    });
  });

  it("DO_SELECT_ALTERNATIVO", () => {
    const context = {
      commit,
      state: {
        paso4: {
          email: "",
          resumenDigital: "mockResumenDigital",
          sucursal: "",
          selectDomicilio: "particular",
          domicilioParticular: {
            calle: "",
            numero: "",
            piso: "",
            dpto: "",
            codigoPostal: "",
            localidad: "",
            codProvincia: "01",
            valido: null
          },
          otroDomicilio: {
            calle: "",
            numero: "",
            piso: "",
            dpto: "",
            codigoPostal: "",
            localidad: "",
            codProvincia: "01",
            valido: null
          },
          searchEncontesa: false
        }
      }
    };
    actions[ACTIONS.DO_SELECT_ALTERNATIVO](context, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_PASO_4, {
      email: "",
      resumenDigital: "mockResumenDigital",
      sucursal: "",
      selectDomicilio: "particular",
      domicilioParticular: {
        calle: "",
        numero: "",
        piso: "",
        dpto: "",
        codigoPostal: "",
        localidad: "",
        codProvincia: "01",
        valido: null
      },
      otroDomicilio: {
        calle: "calleLocalidadTest",
        numero: "",
        piso: "",
        dpto: "",
        codigoPostal: "codigoPostalTest",
        localidad: "",
        codProvincia: "01",
        valido: true,
        searchEncontesa: false,
        lineas: []
      },
      searchEncontesa: false
    });
  });

  it("DO_CONFIRMAR_DATA", () => {
    const payload = {
      cliente: {
        actividadSujetoObligado: "",
        constanciaSujetoObligado: false,
        conyuge: {
          apellido: "",
          nacionalidad: "",
          nombre: "",
          numeroDocumento: "",
          tipoDocumento: "00"
        },
        deviceId: "mocksDeviceId",
        deviceIdTimestamp: "mocksDeviceIdTimestamp",
        domAlternativo: {
          calle: "",
          codProvincia: "CAPITAL FEDERAL",
          codigoPostal: "",
          depto: "",
          localidad: "",
          numero: "",
          piso: "",
          referencia: ""
        },
        domicilio: {
          calle: "",
          codProvincia: "CAPITAL FEDERAL",
          codigoPostal: "",
          depto: "",
          localidad: "",
          numero: "",
          piso: "",
          referencia: ""
        },
        eResumen: "mockResumenDigital",
        eResumenEmail: "",
        emailContacto: "",
        estadoCivil: "5",
        lugarNacimiento: "",
        marcaPEP: false,
        marcaSujetoObligado: false,
        situacionLaboral: "En rel. de dependencia",
        telContacto: {
          area: "11",
          caracteristica: "2875",
          interno: "",
          nro: "6563"
        },
        tipoActividad: "OTROS SERVICIOS",
        tipoOcupacion: "ADMINISTRATIVO",
        tipoPagoTarjeta: "1"
      },
      producto: {
        solicitudSucursal: "0999"
      },
      randomKey: "randomKey"
    };
    actions[ACTIONS.DO_CONFIRMAR_DATA]({ commit, dispatch, getters });
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONFIRMAR,
      doSuccess: ACTIONS.DO_GRACIAS,
      doError: ACTIONS.DO_PASO4_ERROR,
      payload
    });
  });

  it("DO_PASO4_ERROR", () => {
    actions[ACTIONS.DO_PASO4_ERROR]({ commit, dispatch }, payload);
    expect(Vue.$log.error).toHaveBeenCalledWith(payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  });

  it("DO_CONSULTA_ESCLIENTE", () => {
    const payload = {
      nombre: "nombreConsultaTest",
      apellido: "apellidoConsultaTest",
      tipoDocumento: "00",
      numeroDocumento: "99888777",
      sexo: "M",
      fechaNacimiento: "01/01/0476",
      paisCodigo: "80",
      email: "",
      celularNumero: "1128756563"
    };
    actions[ACTIONS.DO_CONSULTA_ESCLIENTE]({ commit, dispatch, getters });
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTA_ESCLIENTE,
      doSuccess: ACTIONS.DO_CONSULTA_ESCLIENTE_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_ESCLIENTE_ERROR,
      payload
    });
  });

  it("DO_CONSULTA_ESCLIENTE_SUCCESS x CLIENTE", () => {
    const payload = {
      respuesta: "CLIENTE"
    };
    router.push = push;
    actions[ACTIONS.DO_CONSULTA_ESCLIENTE_SUCCESS](
      { commit, dispatch },
      payload
    );
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(push).toHaveBeenCalledWith("clienteCA");
  });

  it("DO_CONSULTA_ESCLIENTE_SUCCESS x NO_CLIENTE", () => {
    const payload = {
      respuesta: "NO_CLIENTE"
    };
    router.push = push;
    actions[ACTIONS.DO_CONSULTA_ESCLIENTE_SUCCESS](
      { commit, dispatch },
      payload
    );
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(push).toHaveBeenCalledWith("ofertaCA");
  });

  it("DO_CONSULTA_ESCLIENTE_SUCCESS sin RESPUESTA", () => {
    const payload = {};
    actions[ACTIONS.DO_CONSULTA_ESCLIENTE_SUCCESS](
      { commit, dispatch },
      payload
    );
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  });

  it("DO_CONSULTA_ESCLIENTE_ERROR", () => {
    actions[ACTIONS.DO_CONSULTA_ESCLIENTE_ERROR]({ commit, dispatch });
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  });

  it("DO_CONFIRMAR_DATA_NOCLIENTE", () => {
    const apiPayload = {
      sucursal: "0001",
      nroCliente: "1234567890",
      nombre: "",
      apellido: "",
      email: "",
      celular: " ",
      numeroDoc: "11222333",
      tipoDoc: "00"
    };
    actions[ACTIONS.DO_CONFIRMAR_DATA_NOCLIENTE](
      { commit, dispatch, getters },
      payload
    );
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONFIRMAR_DATA_NOCLIENTE,
      doSuccess: ACTIONS.DO_GRACIAS_NOCLIENTE,
      doError: ACTIONS.DO_QUERY_ERROR,
      payload: apiPayload
    });
  });

  it("DO_GRACIAS_NOCLIENTE", () => {
    router.push = push;
    actions[ACTIONS.DO_GRACIAS_NOCLIENTE]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(push).toHaveBeenCalledWith("noCliente");
  });

  it("DO_GRACIAS x STATUS ERROR", () => {
    const payload = {
      status: "ERROR",
      respuesta: {
        errores: []
      }
    };
    actions[ACTIONS.DO_GRACIAS]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  });

  it("DO_GRACIAS x STATUS ERROR y debe redirigirse a una sucursal", () => {
    router.push = push;
    const payload = {
      status: "ERROR",
      respuesta: {
        errores: ["PAE0754"]
      }
    };
    actions[ACTIONS.DO_GRACIAS]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(push).toHaveBeenCalledWith({ name: "continuaSucursal" });
  });

  it("DO_GRACIAS x STATUS ERROR con errores undefined", () => {
    const payload = {
      status: "ERROR",
      respuesta: {}
    };
    actions[ACTIONS.DO_GRACIAS]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
    expect(router.push).not.toHaveBeenCalled();
  });

  it("DO_GRACIAS x STATUS OK y MENSAJE INDIVIDUO_NEGATIVO", () => {
    const payload = {
      status: "OK",
      respuesta: {
        mensaje: "INDIVIDUO_NEGATIVO"
      }
    };
    actions[ACTIONS.DO_GRACIAS]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(Vue.$log.error).toHaveBeenCalledWith(payload);
    expect(dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_MENSAJE,
      INDIVIDUO_NEGATIVO
    );
  });

  it("DO_GRACIAS x STATUS OK y MENSAJE clienteNoCensado", () => {
    const payload = {
      status: "OK",
      respuesta: {
        mensaje: "clienteNoCensado"
      }
    };
    actions[ACTIONS.DO_GRACIAS]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(Vue.$log.error).toHaveBeenCalledWith(payload);
    expect(dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_MENSAJE,
      CLIENTE_NO_CENSADO
    );
  });

  it("DO_GRACIAS x STATUS OK", () => {
    actions[ACTIONS.DO_GRACIAS]({ commit, getters }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_GRACIAS, payload);
  });

  it("DO_SUCURSAL", () => {
    actions[ACTIONS.DO_SUCURSAL]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_SUCURSAL, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_CONFIRMAR_DATA_SUCURSAL);
  });

  it("DO_CONFIRMAR_DATA_SUCURSAL", () => {
    const payload = {
      nombre: "nombreConsultaTest",
      apellido: "apellidoConsultaTest",
      tipoDocumento: "00",
      numeroDocumento: "99888777",
      sexo: "M",
      fechaNacimiento: "01/01/0476",
      paisCodigo: "80",
      celularNumero: "1128756563",
      numeroSucursal: "1",
      email: "",
      cuil: "20-00000000-0"
    };
    actions[ACTIONS.DO_CONFIRMAR_DATA_SUCURSAL](
      { commit, dispatch, getters },
      payload
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.ALTA_CLIENTE_CA,
      doSuccess: ACTIONS.DO_GRACIAS_CA,
      doError: ACTIONS.DO_SUCURSAL_ERROR,
      payload
    });
  });

  it("DO_CONFIRMAR_DATA_SUCURSAL x ofertaCGU", () => {
    global._BBVA_MOTOR = "ofertaCGU";
    const payload = {
      nombre: "nombreConsultaTest",
      apellido: "apellidoConsultaTest",
      tipoDocumento: "00",
      numeroDocumento: "99888777",
      sexo: "M",
      fechaNacimiento: "01/01/0476",
      paisCodigo: "80",
      celularNumero: "1128756563",
      numeroSucursal: "1",
      email: "",
      cuil: "20-00000000-0"
    };
    actions[ACTIONS.DO_CONFIRMAR_DATA_SUCURSAL](
      { commit, dispatch, getters },
      payload
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.ALTA_CLIENTE_CGU,
      doSuccess: ACTIONS.DO_GRACIAS_CA,
      doError: ACTIONS.DO_SUCURSAL_ERROR,
      payload
    });
  });

  it("DO_CONFIRMAR_DATA_SUCURSAL x ofertaCajaAhorro", () => {
    global._BBVA_MOTOR = "ofertaCajaAhorro";
    const payload = {
      nombre: "nombreConsultaTest",
      apellido: "apellidoConsultaTest",
      tipoDocumento: "00",
      numeroDocumento: "99888777",
      sexo: "M",
      fechaNacimiento: "01/01/0476",
      paisCodigo: "80",
      celularNumero: "1128756563",
      numeroSucursal: "1",
      email: "",
      cuil: "20-00000000-0"
    };
    actions[ACTIONS.DO_CONFIRMAR_DATA_SUCURSAL](
      { commit, dispatch, getters },
      payload
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.ALTA_CLIENTE_CAJA_AHORRO,
      doSuccess: ACTIONS.DO_GRACIAS_CA,
      doError: ACTIONS.DO_SUCURSAL_ERROR,
      payload
    });
  });

  it("DO_CONFIRMAR_DATA_SUCURSAL x ofertaEmprendedores", () => {
    global._BBVA_MOTOR = "ofertaEmprendedores";
    const payload = {
      nombre: "nombreConsultaTest",
      apellido: "apellidoConsultaTest",
      tipoDocumento: "00",
      numeroDocumento: "99888777",
      sexo: "M",
      fechaNacimiento: "01/01/0476",
      paisCodigo: "80",
      celularNumero: "1128756563",
      numeroSucursal: "1",
      email: "",
      cuil: "20-00000000-0"
    };
    actions[ACTIONS.DO_CONFIRMAR_DATA_SUCURSAL](
      { commit, dispatch, getters },
      payload
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.ALTA_CLIENTE_CAJA_AHORRO,
      doSuccess: ACTIONS.DO_GRACIAS_CA,
      doError: ACTIONS.DO_SUCURSAL_ERROR,
      payload
    });
  });

  it("DO_SUCURSAL_ERROR", () => {
    actions[ACTIONS.DO_SUCURSAL_ERROR]({ commit, dispatch }, payload);
    expect(Vue.$log.error).toHaveBeenCalledWith(payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  });

  it("DO_GRACIAS_CA x STATUS OK", () => {
    router.push = push;
    const payload = {
      status: "OK",
      respuesta: "CLIENTE"
    };
    actions[ACTIONS.DO_GRACIAS_CA]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(Vue.$log.error).toHaveBeenCalledWith(payload);
    expect(push).toHaveBeenCalledWith("clienteCA");
  });

  it("DO_GRACIAS_CA x ERROR YA_CONVERTIDO", () => {
    const payload = {
      status: "ERROR",
      respuesta: "YA_CONVERTIDO"
    };
    actions[ACTIONS.DO_GRACIAS_CA]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(Vue.$log.error).toHaveBeenCalledWith(payload);
    expect(dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_MENSAJE,
      INDIVIDUO_NEGATIVO
    );
  });

  it("DO_GRACIAS_CA x ERROR JAHE160", () => {
    router.push = push;
    const payload = {
      status: "ERROR",
      respuesta: "JAHE160"
    };
    actions[ACTIONS.DO_GRACIAS_CA]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(push).toHaveBeenCalledWith("errorBBVAVos");
  });

  it("DO_GRACIAS_CA x ERROR AHE0160", () => {
    router.push = push;
    const payload = {
      status: "ERROR",
      respuesta: "AHE0160"
    };
    actions[ACTIONS.DO_GRACIAS_CA]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(push).toHaveBeenCalledWith("errorBBVAVos");
  });

  it("DO_GRACIAS_CA x ERROR CUALQUIERA", () => {
    const payload = {
      status: "ERROR",
      respuesta: "CUALQUIERA"
    };
    actions[ACTIONS.DO_GRACIAS_CA]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(Vue.$log.error).toHaveBeenCalledWith(payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  });

  it("DO_GRACIAS_CA x STATUS OK y RESPUESTA CUALQUIERA", () => {
    router.push = push;
    const payload = {
      status: "OK",
      respuesta: "CUALQUIERA"
    };
    actions[ACTIONS.DO_GRACIAS_CA]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_GRACIAS_CA, payload);
    expect(push).toHaveBeenCalledWith("graciasCA");
  });

  it("DO_SOLICITAR_TURNO", () => {
    actions[ACTIONS.DO_SOLICITAR_TURNO]({ commit, dispatch, getters }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_SOLICITAR_TURNO, payload);
  });

  it("DO_SOCIAL_NET", () => {
    actions[ACTIONS.DO_SOCIAL_NET]({ commit, dispatch, getters }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.SOCIAL_NET,
      doSuccess: ACTIONS.DO_SOCIAL_NET_SUCCESS,
      doError: ACTIONS.DO_SOCIAL_NET_ERROR,
      payload: {
        caracteristicaTel: "",
        nroTel: "",
        randomKey: "randomKey"
      }
    });
  });

  /**
   * ESTA MAL DEFINIDO EL ACTION YTPE
   * LE APUNTA SIEMPRE AL CO_SOCIAL_NET_SUCCESS
   */
  // eslint-disable-next-line jest/no-disabled-tests
  it("DO_SOCIAL_NET_ERROR", () => {
    const payload = {
      respuesta: { status: "OK" }
    };
    actions[ACTIONS.DO_SOCIAL_NET_ERROR]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_SOCIAL_NET_STATUS,
      payload
    );
  });

  it("DO_SOCIAL_NET_SUCCESS sin STATUS", () => {
    const payload = {
      respuesta: {}
    };
    actions[ACTIONS.DO_SOCIAL_NET_SUCCESS]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_SOCIAL_NET_STATUS,
      "ERROR"
    );
  });

  it("DO_SOCIAL_NET_SUCCESS con STATUS", () => {
    const payload = {
      respuesta: { status: "OK" }
    };
    actions[ACTIONS.DO_SOCIAL_NET_SUCCESS]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_SOCIAL_NET_STATUS,
      "SUCCESS"
    );
  });

  it("DO_MENSAJE", () => {
    router.push = push;
    actions[ACTIONS.DO_MENSAJE]({ commit }, payload);
    expect(push).toHaveBeenCalledWith({
      name: "mensaje",
      params: {
        mje: payload
      }
    });
  });

  it("DO_SEARCH_ENCOTESA", () => {
    actions[ACTIONS.DO_SEARCH_ENCOTESA]({ commit, dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.SEARCH_ENCOTESA,
      doSuccess: ACTIONS.DO_SEARCH_ENCOTESA_SUCCESS,
      doError: ACTIONS.DO_SEARCH_ENCOTESA_ERROR,
      payload: {
        orden: "test",
        domicilio: {
          codProvincia: "01",
          departamento: "dptoTest",
          depto: "dptoTest",
          provincia: "01"
        }
      }
    });
  });

  it("DO_SEARCH_ENCOTESA_SUCCESS", () => {
    const payload = {
      status: "OK",
      respuesta: {
        domicilios: { domicilio: "test" }
      }
    };
    actions[ACTIONS.DO_SEARCH_ENCOTESA_SUCCESS]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_SEARCH_ENCOTESA, {
      domicilio: "test"
    });
  });

  it("DO_SEARCH_ENCOTESA_ERROR", () => {
    actions[ACTIONS.DO_SEARCH_ENCOTESA_ERROR]({ commit, dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  });

  it("DO_CLICK_TRACKING", () => {
    const state = {
      trackClickElement: null
    };
    actions[ACTIONS.DO_CLICK_TRACKING]({ commit, dispatch, state }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ADOBE_APP_STARTED, payload);
  });

  it("DO_INTERNAL_LINK", () => {
    actions[ACTIONS.DO_INTERNAL_LINK]({ commit, getters }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_INTERNAL_LINK, payload);
  });

  it("DO_INGRESO_BANCA_ONLINE", () => {
    actions[ACTIONS.DO_INGRESO_BANCA_ONLINE]({ commit, getters });
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_INGRESO_BANCA_ONLINE,
      "mensajeErrorSolicitudCuenta"
    );
  });

  it("DO_MOCK", () => {
    actions[ACTIONS.DO_MOCK]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_MOCK, payload);
  });

  it("DO_OPEN_MODAL", () => {
    actions[ACTIONS.DO_OPEN_MODAL]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_OPEN_MODAL, payload);
  });

  it("doSelectEncotesaParticular", () => {
    actions[ACTIONS.doSelectEncotesaParticular]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.onSelectEncotesaParticular,
      payload
    );
  });

  it("doSelectEncotesaAlternativo", () => {
    actions[ACTIONS.doSelectEncotesaAlternativo]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.onSelectEncotesaAlternativo,
      payload
    );
  });

  it("doTCode", () => {
    actions[ACTIONS.doTCode]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.onTCode, payload);
  });

  it("DO_GET_DEVICEID", () => {
    actions[ACTIONS.DO_GET_DEVICEID]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_DEVICEID, payload);
  });

  it("DO_GET_DEVICEIDTIMESTAMP", () => {
    actions[ACTIONS.DO_GET_DEVICEIDTIMESTAMP]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_DEVICEIDTIMESTAMP,
      payload
    );
  });

  it("DO_GET_TOKEN_USER_ID", () => {
    actions[ACTIONS.DO_GET_TOKEN_USER_ID]({ commit, dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.TOKENIZAR_USER,
      doSuccess: ACTIONS.DO_TOKENIZAR_USER_SUCCESS,
      doError: ACTIONS.DO_TOKENIZAR_USER_ERROR,
      payload: payload
    });
  });

  it("DO_TOKENIZAR_USER_SUCCESS", () => {
    const response = {
      status: "OK",
      respuesta: {
        customerID: "MOCK_customerID"
      }
    };
    actions[ACTIONS.DO_TOKENIZAR_USER_SUCCESS]({ commit }, response);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_USER_TOKENIZADO,
      "MOCK_customerID"
    );
  });

  it("DO_TOKENIZAR_USER_ERROR", async () => {
    const response = { status: "ERROR", error: "MOCK_error" };
    actions[ACTIONS.DO_TOKENIZAR_USER_ERROR]({ commit }, response);
    expect(Vue.$log.error).toHaveBeenCalledWith({
      status: "ERROR",
      error: "MOCK_error"
    });
  });
  it("DO_CONSULTA x ofertaCGU", () => {
    global._BBVA_MOTOR = "ofertaCGU";
    let payloadAux = {
      nombre: "",
      apellido: "",
      tipoDoc: "00",
      nroDoc: "11222333",
      numeroDoc: "11222333",
      nacionalidad: "80",
      sexo: "F",
      fechaNacimiento: "01/01/1492",
      email: "",
      caracteristicaTel: "",
      nroTel: "",
      captchaResponse: "",
      tipoResidencia: "",
      c: "ofertaCGUmockTCode",
      fingerprint: "9999991212",
      referrer: "",
      originUrl: "http://localhost/",
      circuito: "CGU"
    };
    actions[ACTIONS.DO_CONSULTA]({ commit, dispatch, getters }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_OFERTA,
      doSuccess: ACTIONS.DO_CONSULTA_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_ERROR,
      payload: payloadAux,
      payloadSuccess: payloadAux
    });
  });

  it("DO_CONSULTA x ofertaCajaAhorro", () => {
    global._BBVA_MOTOR = "ofertaCajaAhorro";
    let payloadAux = {
      nombre: "",
      apellido: "",
      tipoDoc: "00",
      nroDoc: "11222333",
      numeroDoc: "11222333",
      nacionalidad: "80",
      sexo: "F",
      fechaNacimiento: "01/01/1492",
      email: "",
      caracteristicaTel: "",
      nroTel: "",
      captchaResponse: "",
      tipoResidencia: "",
      c: "ofertaCajaAhorromockTCode",
      fingerprint: "9999991212",
      referrer: "",
      originUrl: "http://localhost/",
      circuito: "SUE"
    };
    actions[ACTIONS.DO_CONSULTA]({ commit, dispatch, getters }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_OFERTA,
      doSuccess: ACTIONS.DO_CONSULTA_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_ERROR,
      payload: payloadAux,
      payloadSuccess: payloadAux
    });
  });

  it("DO_CONSULTA x ofertaNomina", () => {
    global._BBVA_MOTOR = "ofertaNomina";
    let payloadAux = {
      nombre: "",
      apellido: "",
      tipoDoc: "00",
      nroDoc: "11222333",
      numeroDoc: "11222333",
      nacionalidad: "80",
      sexo: "F",
      fechaNacimiento: "01/01/1492",
      email: "",
      caracteristicaTel: "",
      nroTel: "",
      captchaResponse: "",
      tipoResidencia: "",
      c: "ofertaNominamockTCode",
      fingerprint: "9999991212",
      referrer: "",
      originUrl: "http://localhost/"
    };
    actions[ACTIONS.DO_CONSULTA]({ commit, dispatch, getters }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_OFERTA,
      doSuccess: ACTIONS.DO_CONSULTA_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_ERROR,
      payload: payloadAux,
      payloadSuccess: payloadAux
    });
  });

  it("DO_CONSULTA x ofertaEmprendedores", () => {
    global._BBVA_MOTOR = "ofertaEmprendedores";
    let payloadAux = {
      nombre: "",
      apellido: "",
      tipoDoc: "00",
      nroDoc: "11222333",
      numeroDoc: "11222333",
      nacionalidad: "80",
      sexo: "F",
      fechaNacimiento: "01/01/1492",
      email: "",
      caracteristicaTel: "",
      nroTel: "",
      captchaResponse: "",
      tipoResidencia: "",
      c: "ofertaEmprendedoresmockTCode",
      fingerprint: "9999991212",
      referrer: "",
      originUrl: "http://localhost/",
      circuito: "EMP"
    };
    actions[ACTIONS.DO_CONSULTA]({ commit, dispatch, getters }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_OFERTA,
      doSuccess: ACTIONS.DO_CONSULTA_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_ERROR,
      payload: payloadAux,
      payloadSuccess: payloadAux
    });
  });

  it("DO_CONSULTA_SUCCESS x STATUS = OK y tipomje", () => {
    router.push = push;
    let response = {
      status: "OK",
      respuesta: {
        validacionRiesgosResponse: { validacionCoelsaExitosa: true },
        oferta: {
          dictamen: "",
          nroDeTramite: "",
          randomkey: "",
          valid: true,
          tipoMje: "mensaje-7"
        },
        evaluacionCompleta: {
          fechaNacimiento: "10-10-2000",
          nombres: "Juan",
          apellidos: "Perez",
          tipoDocumento: "00",
          numeroDocumento: "12345678",
          codigoNacionalidad: "80",
          sexo: "M",
          email: "test@test.com"
        }
      },
      payloadSuccess: {
        hash: "abc"
      }
    };
    actions[ACTIONS.DO_CONSULTA_SUCCESS]({ commit, dispatch }, response);
    expect(dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_MENSAJE,
      INDIVIDUO_NEGATIVO
    );
    response.respuesta.oferta.tipoMje = "mensaje-5";
    let mockState = { ...state, confirmarRenaper: { yaValido: false } };
    actions[ACTIONS.DO_CONSULTA_SUCCESS](
      { state: mockState, commit, dispatch },
      response
    );
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_CONFIRMAR_RENAPER_FLAG,
      true
    );
    mockState.confirmarRenaper.yaValido = true;
    actions[ACTIONS.DO_CONSULTA_SUCCESS](
      { state: mockState, commit, dispatch },
      response
    );
    expect(dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_MENSAJE,
      ERROR_CONFIRMACION_RENAPER
    );
    response.respuesta.oferta.tipoMje = "mensaje-4";
    actions[ACTIONS.DO_CONSULTA_SUCCESS]({ commit, dispatch }, response);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
    response.respuesta.oferta = null;
    actions[ACTIONS.DO_CONSULTA_SUCCESS]({ commit, dispatch }, response);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  });

  it("DO_CONSULTA_SUCCESS x STATUS = OK y SIN cuenta", () => {
    router.push = push;
    const response = {
      status: "OK",
      respuesta: {
        validacionRiesgosResponse: { validacionCoelsaExitosa: true },
        oferta: {
          dictamen: "",
          nroDeTramite: "",
          randomkey: "",
          valid: true
        },
        evaluacionCompleta: {
          fechaNacimiento: "10-10-2000",
          nombres: "Juan",
          apellidos: "Perez",
          tipoDocumento: "00",
          numeroDocumento: "12345678",
          codigoNacionalidad: "80",
          sexo: "M",
          email: "test@test.com"
        }
      },
      payloadSuccess: {
        hash: "abc"
      }
    };
    actions[ACTIONS.DO_CONSULTA_SUCCESS](
      { getters, commit, dispatch },
      response
    );
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_OFFER, response.respuesta);
  });

  it("DO_CONSULTA_SUCCESS x STATUS = OK y cuenta en ofertaEmprendedores", () => {
    global._BBVA_MOTOR = "ofertaEmprendedores";
    router.push = push;
    let expectedPayload = "";
    const response = {
      status: "OK",
      respuesta: {
        validacionRiesgosResponse: { validacionCoelsaExitosa: true },
        oferta: {
          dictamen: "",
          nroDeTramite: "",
          randomkey: "",
          valid: true
        },
        evaluacionCompleta: {
          fechaNacimiento: "10-10-2000",
          nombres: "Juan",
          apellidos: "Perez",
          tipoDocumento: "00",
          numeroDocumento: "12345678",
          codigoNacionalidad: "80",
          sexo: "M",
          email: "test@test.com",
          hash: "asdf"
        },
        esCliente: true
      },
      payloadSuccess: {}
    };
    actions[ACTIONS.DO_CONSULTA_SUCCESS](
      { getters, commit, dispatch },
      response
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTAR_CUENTA_CLIENTE_EMPRENDEDORES,
      doSuccess: ACTIONS.DO_CONSULTA_CUENTA_CLIENTE_SUCCESS,
      doError: ACTIONS.DO_CONSULTA_ERROR,
      payload: expectedPayload
    });
  });

  it("DO_CONSULTA_SUCCESS x STATUS = OK con hash ofertaCuenta", () => {
    global._BBVA_MOTOR = "ofertaCajaAhorro";
    const response = {
      status: "OK",
      respuesta: {
        validacionRiesgosResponse: { validacionCoelsaExitosa: true },
        oferta: {
          dictamen: "",
          nroDeTramite: "",
          randomkey: "",
          valid: true
        },
        esCliente: true
      },
      payloadSuccess: {}
    };
    actions[ACTIONS.DO_CONSULTA_SUCCESS](
      { getters, commit, dispatch },
      response
    );
    expect(router.push).toHaveBeenCalled();
  });

  it("DO_CONSULTA_SUCCESS x STATUS = ERROR", () => {
    const response = {
      status: "ERROR",
      respuesta: {
        validacionRiesgosResponse: { validacionCoelsaExitosa: true },
        includes: () => false
      }
    };
    actions[ACTIONS.DO_CONSULTA_SUCCESS]({ commit, dispatch }, response);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  });

  it("DO_CONSULTA_SUCCESS x STATUS = ERROR CA ACTIVA", () => {
    const response = {
      status: "ERROR",
      respuesta: {
        validacionRiesgosResponse: { validacionCoelsaExitosa: true },
        includes: () => true
      }
    };
    actions[ACTIONS.DO_CONSULTA_SUCCESS]({ commit, dispatch }, response);
    expect(router.push).toHaveBeenCalledWith({
      name: "mensajeErrorSolicitudCuenta",
      params: { mje: ERROR_SOLICITUD }
    });
  });

  it("DO_CONSULTA_SUCCESS x STATUS = ERROR CA ACTIVA ofertaEmprendedores", () => {
    global._BBVA_MOTOR = "ofertaEmprendedores";
    const response = {
      status: "ERROR",
      respuesta: {
        validacionRiesgosResponse: { validacionCoelsaExitosa: true },
        includes: () => true
      },
      payloadSuccess: {
        nroDoc: ""
      }
    };
    actions[ACTIONS.DO_CONSULTA_SUCCESS]({ commit, dispatch }, response);
    expect(dispatch).toHaveBeenCalled(ACTIONS.doCaminoOfertaEmprendedores, {});
  });

  it("DO_CONSULTA_SUCCESS status OK y HASH", () => {
    global._BBVA_MOTOR = "ofertaNomina";
    router.push.mockReturnValue(Promise.resolve());
    router.replace = jest.fn();

    const data = {
      status: "OK",
      respuesta: {
        validacionRiesgosResponse: { validacionCoelsaExitosa: true },
        oferta: {
          numeroCliente: "123456",
          tipoMje: "",
          segmentoScoreCliente: "A"
        },
        nroDeTramite: "123456",
        randomkey: "randomkey123",
        respuestaCaminosClientes: {
          camino: "1"
        },
        evaluacionCompleta: {
          hash: "testHash",
          fechaNacimiento: "10-10-2000",
          nombres: "Juan",
          apellidos: "Perez",
          tipoDocumento: "00",
          numeroDocumento: "12345678",
          codigoNacionalidad: "80",
          sexo: "M",
          email: "test@test.com"
        }
      },
      payloadSuccess: {
        hash: "testHash"
      }
    };

    actions[ACTIONS.DO_CONSULTA_SUCCESS]({ commit, dispatch, getters }, data);

    expect(router.push).toHaveBeenCalledWith("/dummy");
  });

  it("DO_CONSULTA_SUCCESS x validacionCoelsaExitosa FALSE redirige a continuaSucursal", () => {
    router.push = push;
    const response = {
      status: "OK",
      respuesta: {
        validacionRiesgosResponse: { validacionCoelsaExitosa: false },
        oferta: {
          dictamen: "",
          nroDeTramite: "",
          randomkey: "",
          valid: true
        }
      }
    };
    actions[ACTIONS.DO_CONSULTA_SUCCESS]({ commit, dispatch }, response);
    expect(push).toHaveBeenCalledWith({
      name: "continuaSucursal",
      params: { mensaje: "mensaje-2" }
    });
    expect(dispatch).not.toHaveBeenCalled();
  });

  it("DO_CONSULTA_SUCCESS x validacionCoelsaExitosa TRUE continua flujo normal", () => {
    router.push = push;
    const response = {
      status: "OK",
      respuesta: {
        validacionRiesgosResponse: { validacionCoelsaExitosa: true },
        oferta: {
          dictamen: "",
          nroDeTramite: "",
          randomkey: "",
          valid: true
        },
        evaluacionCompleta: {
          fechaNacimiento: "10-10-2000",
          nombres: "Juan",
          apellidos: "Perez",
          tipoDocumento: "00",
          numeroDocumento: "12345678",
          codigoNacionalidad: "80",
          sexo: "M",
          email: "test@test.com"
        }
      },
      payloadSuccess: {}
    };
    actions[ACTIONS.DO_CONSULTA_SUCCESS](
      { commit, dispatch, getters },
      response
    );
    expect(push).not.toHaveBeenCalledWith({ name: "continuaSucursal" });
  });

  it("DO_CONSULTA_CUENTA_CLIENTE_SUCCESS", () => {
    const payload = {
      respuesta: {
        cuenta: ""
      }
    };
    actions[ACTIONS.DO_CONSULTA_CUENTA_CLIENTE_SUCCESS](
      { commit, dispatch },
      payload
    );
    expect(router.push).toHaveBeenCalledWith("/ofertaCuenta");
  });

  it("DO_ENVIO_SMS", () => {
    actions[ACTIONS.DO_ENVIO_SMS]({ commit, dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.ENVIAR_SMS,
      doSuccess: ACTIONS.DO_ENVIO_SMS_SUCCESS,
      doError: ACTIONS.DO_ENVIO_SMS_ERROR,
      payload: payload
    });
  });

  it("DO_ENVIO_SMS_SUCCESS", () => {
    const data = {
      status: "OK"
    };
    actions[ACTIONS.DO_ENVIO_SMS_SUCCESS]({ commit, dispatch }, data);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_NOTIFICATION_TOAST, {
      type: "success",
      message: "Se envió el SMS."
    });
  });

  it("DO_ENVIO_SMS_SUCCESS x ERROR", () => {
    const data = {
      status: "ERROR"
    };
    actions[ACTIONS.DO_ENVIO_SMS_SUCCESS]({ commit, dispatch }, data);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_NOTIFICATION_TOAST, {
      type: "alert",
      message: "Hubo un error en el envío. Intente nuevamente."
    });
  });

  it("DO_ENVIO_SMS_ERROR", () => {
    actions[ACTIONS.DO_ENVIO_SMS_ERROR]({ commit, dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_NOTIFICATION_TOAST, {
      type: "alert",
      message: "Hubo un error en el envío. Intente nuevamente."
    });
  });

  it("DO_CONSULTAR_DOMICILIO", () => {
    actions[ACTIONS.DO_CONSULTAR_DOMICILIO]({
      state,
      getters,
      commit,
      dispatch
    });
    expect(dispatch).toHaveBeenCalledTimes(2);
  });

  it("DO_CONSULTAR_DOMICILIO_SUCCESS status OK", () => {
    const data = {
      status: "OK",
      respuesta: {
        codPais: "",
        codProv: "",
        localid: ""
      },
      payloadSuccess: PCG7.TDOMIC.PARTICULAR
    };
    actions[ACTIONS.DO_CONSULTAR_DOMICILIO_SUCCESS](
      { commit, getters, dispatch },
      data
    );
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_DOMICILIO,
      getters.getDomicilio("06")
    );
  });

  it("DO_CONSULTAR_DOMICILIO_SUCCESS status ERROR", () => {
    const data = {
      status: "ERROR",
      respuesta: {},
      payloadSuccess: PCG7.TDOMIC.PARTICULAR,
      errorCode: ""
    };
    actions[ACTIONS.DO_CONSULTAR_DOMICILIO_SUCCESS](
      { commit, getters, dispatch },
      data
    );
    expect(dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_CONSULTAR_DOMICILIO_ERROR,
      ""
    );
  });

  it("DO_CONSULTAR_DOMICILIO_ERROR status ERROR", () => {
    const error = "";
    actions[ACTIONS.DO_CONSULTAR_DOMICILIO_ERROR]({ commit, dispatch }, error);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  });

  it("DO_DATOS_PERSONALES", () => {
    const payload = {
      model: {},
      modelDomicilio: {}
    };
    actions[ACTIONS.DO_DATOS_PERSONALES]({ commit, dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_VALIDAR_DOMICILIO, {
      modelDomicilio: {},
      nextStep: "/datosLaborales"
    });
  });

  it("DO_VALIDAR_DOMICILIO", () => {
    const payload = {
      modelDomicilio: {
        codPost: "",
        desDomi: ""
      },
      nextStep: "",
      tipoDomicilio: ""
    };
    actions[ACTIONS.DO_VALIDAR_DOMICILIO](
      { state, commit, getters, dispatch },
      payload
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.VALIDAR_DOMICILIO,
      doSuccess: ACTIONS.DO_VALIDAR_DOMICILIO_SUCCESS,
      doError: ACTIONS.DO_VALIDAR_DOMICILIO_ERROR,
      payload: {
        accion: "02",
        codPost: "00000",
        desDomi: " S/N",
        numClie: "1234567890",
        opcion: "A",
        tDomic: ""
      },
      payloadSuccess: {
        modelDomicilio: {
          codPost: "",
          desDomi: ""
        },
        nextStep: "",
        tipoDomicilio: ""
      }
    });
  });

  it("DO_VALIDAR_DOMICILIO_SUCCESS status OK domicilio INUSUAL", () => {
    const data = {
      status: "OK",
      respuesta: {},
      payloadSuccess: {
        modelDomicilio: {
          inusual: true
        },
        nextStep: "",
        tipoDomicilio: ""
      }
    };
    actions[ACTIONS.DO_VALIDAR_DOMICILIO_SUCCESS](
      { commit, dispatch, getters },
      data
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_GRABAR_DOMICILIO, {
      modelDomicilio: {
        inusual: true
      },
      nextStep: "",
      tipoDomicilio: ""
    });
  });

  it("DO_VALIDAR_DOMICILIO_SUCCESS status OK domicilio NO INUSUAL dudas 0", () => {
    const data = {
      status: "OK",
      respuesta: {
        codPais: "80",
        codPost: "10",
        localid: "CABA",
        desDomi: "CABA",
        coorX: "00.000001",
        coorY: "00.000001",
        dudas: []
      },
      payloadSuccess: {
        modelDomicilio: {
          inusual: false
        },
        nextStep: "",
        tipoDomicilio: "10"
      }
    };
    const modelDomicilio = getters.getDomicilio("10");
    actions[ACTIONS.DO_VALIDAR_DOMICILIO_SUCCESS](
      { commit, dispatch, getters },
      data
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_PROCESAR_DOMICILIO, {
      modelDomicilio,
      nextStep: "",
      tipoDomicilio: "10"
    });
  });

  it("DO_VALIDAR_DOMICILIO_SUCCESS status OK domicilio NO INUSUAL dudas > 0", () => {
    const data = {
      status: "OK",
      respuesta: {
        codPais: "80",
        codPost: "10",
        localid: "CABA",
        desDomi: "CABA",
        coorX: "00.000000",
        coorY: "00.000000",
        dudas: [{}]
      },
      payloadSuccess: {
        modelDomicilio: {
          inusual: false
        }
      }
    };
    actions[ACTIONS.DO_VALIDAR_DOMICILIO_SUCCESS]({ commit, dispatch }, data);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_DOMICILIO, {
      codPais: "80",
      codPost: "10",
      localid: "CABA",
      desDomi: "CABA",
      coorX: "00.000000",
      coorY: "00.000000",
      dudas: [{}],
      inusual: false
    });
  });

  it("DO_VALIDAR_DOMICILIO_SUCCESS status OK domicilio NO INUSUAL a INUSUAL", () => {
    const data = {
      status: "OK",
      respuesta: {
        inusual: false
      },
      payloadSuccess: {
        modelDomicilio: {
          inusual: false
        }
      }
    };
    actions[ACTIONS.DO_VALIDAR_DOMICILIO_SUCCESS]({ commit, dispatch }, data);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_DOMICILIO, {
      inusual: true
    });
  });

  it("DO_VALIDAR_DOMICILIO_ERROR", () => {
    actions[ACTIONS.DO_VALIDAR_DOMICILIO_ERROR]({ commit, dispatch }, "");
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  });

  it("DO_PROCESAR_DOMICILIO", () => {
    const payload = {
      modelDomicilio: {},
      nextStep: "",
      tipoDomicilio: "10"
    };
    actions[ACTIONS.DO_PROCESAR_DOMICILIO](
      { commit, getters, dispatch },
      payload
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.PROCESAR_DOMICILIO,
      doSuccess: ACTIONS.DO_PROCESAR_DOMICILIO_SUCCESS,
      doError: ACTIONS.DO_PROCESAR_DOMICILIO_ERROR,
      payload: {
        accion: "01"
      },
      payloadSuccess: {
        modelDomicilio: {
          accion: "01"
        },
        nextStep: "",
        tipoDomicilio: "10"
      }
    });
  });

  it("ACTIONS.DO_PROCESAR_DOMICILIO_SUCCESS status OK", () => {
    const data = {
      status: "OK",
      respuesta: {
        errores: []
      },
      payloadSuccess: {
        modelDomicilio: {},
        tipoDomicilio: "",
        nextStep: ""
      }
    };
    actions[ACTIONS.DO_PROCESAR_DOMICILIO_SUCCESS]({ commit, dispatch }, data);
    expect(processHandleOkStatus).toHaveBeenCalledTimes(1);
    expect(processHandleOkStatus).toHaveBeenCalledWith(
      { commit, dispatch },
      {},
      "",
      {
        status: "OK",
        respuesta: {
          errores: []
        },
        payloadSuccess: {
          modelDomicilio: {},
          tipoDomicilio: "",
          nextStep: ""
        }
      },
      [],
      ""
    );
  });

  it("ACTIONS.DO_PROCESAR_DOMICILIO_SUCCESS status ERROR", () => {
    const data = {
      status: "ERROR",
      respuesta: {},
      payloadSuccess: {
        modelDomicilio: {},
        tipoDomicilio: "",
        nextStep: ""
      }
    };
    actions[ACTIONS.DO_PROCESAR_DOMICILIO_SUCCESS]({ commit, dispatch }, data);
    expect(processHandleErrorStatus).toHaveBeenCalledTimes(1);
    expect(processHandleErrorStatus).toHaveBeenCalledWith(
      { commit, dispatch },
      {},
      {
        status: "ERROR",
        respuesta: {},
        payloadSuccess: {
          modelDomicilio: {},
          tipoDomicilio: "",
          nextStep: ""
        }
      }
    );
  });

  it("DO_PROCESAR_DOMICILIO_ERROR", () => {
    actions[ACTIONS.DO_PROCESAR_DOMICILIO_ERROR]({ commit, dispatch }, "");
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  });

  it("DO_GRABAR_DOMICILIO", () => {
    const payload = {
      modelDomicilio: {},
      nextStep: "",
      tipoDomicilio: ""
    };
    actions[ACTIONS.DO_GRABAR_DOMICILIO]({ commit, dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.GRABAR_DOMICILIO,
      doSuccess: ACTIONS.DO_GRABAR_DOMICILIO_SUCCESS,
      doError: ACTIONS.DO_GRABAR_DOMICILIO_ERROR,
      payload: {},
      payloadSuccess: { modelDomicilio: {}, nextStep: "", tipoDomicilio: "" }
    });
  });

  it("DO_GRABAR_DOMICILIO_SUCCESS status OK", () => {
    const data = {
      status: "OK",
      respuesta: {
        errores: []
      },
      payloadSuccess: {
        modelDomicilio: {},
        tipoDomicilio: "",
        nextStep: ""
      }
    };
    actions[ACTIONS.DO_GRABAR_DOMICILIO_SUCCESS]({ commit, dispatch }, data);
    expect(guardarHandleOkStatus).toHaveBeenCalledTimes(1);
    expect(guardarHandleOkStatus).toHaveBeenCalledWith(
      { commit, dispatch },
      {},
      "",
      {
        status: "OK",
        respuesta: {
          errores: []
        },
        payloadSuccess: {
          modelDomicilio: {},
          tipoDomicilio: "",
          nextStep: ""
        }
      },
      [],
      ""
    );
  });

  it("DO_GRABAR_DOMICILIO_SUCCESS status ERROR", () => {
    const data = {
      status: "ERROR",
      respuesta: {
        errores: []
      }
    };
    actions[ACTIONS.DO_GRABAR_DOMICILIO_SUCCESS]({ commit, dispatch }, data);
    expect(guardarHandleOkStatus).toHaveBeenCalledTimes(0);
    expect(dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_GRABAR_DOMICILIO_ERROR,
      "no se pudo procesar domicilio"
    );
  });

  it("DO_GRABAR_DOMICILIO_ERROR", () => {
    actions[ACTIONS.DO_GRABAR_DOMICILIO_ERROR]({ commit, dispatch }, "");
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  });

  it("DO_FETCH_SUCURSALES", async () => {
    const payload = {};
    try {
      om.sucursales.mockResolvedValue({ data: { data: {} } });
      await actions[ACTIONS.DO_FETCH_SUCURSALES]({ commit }, payload);
      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_SUCURSALES, {});
    } catch (error) {
      console.log(error);
    }
  });

  it("DO_DATOS_LABORALES", () => {
    const payload = {};
    actions[ACTIONS.DO_DATOS_LABORALES]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_DATOS_LABORALES, {});
  });

  it("DO_INFORMACION_ADICIONAL continuaSucursal", () => {
    const payload = {
      pep: "1",
      sujetoObligado: "1",
      fatca: "1"
    };
    actions[ACTIONS.DO_INFORMACION_ADICIONAL]({ commit }, payload);
    expect(router.push).toHaveBeenCalledWith({
      name: "continuaSucursal",
      params: { mensaje: "mensaje-1" }
    });
  });

  it("DO_INFORMACION_ADICIONAL", () => {
    const payload = {
      pep: "0",
      sujetoObligado: "0",
      fatca: "0"
    };
    actions[ACTIONS.DO_INFORMACION_ADICIONAL]({ commit }, payload);
    expect(router.push).toHaveBeenCalledWith("/identidad");
  });

  describe("DO_INFORMACION_ADICIONAL - validacion de riesgo", () => {
    const payload = { pep: "0", sujetoObligado: "0", fatca: "0" };

    it("ofertaCajaAhorro - validRisk true → commitea payload y push al siguiente paso", async () => {
      global._BBVA_MOTOR = "ofertaCajaAhorro";
      dispatch.mockResolvedValueOnce(true);

      await actions[ACTIONS.DO_INFORMACION_ADICIONAL](
        { commit, dispatch },
        payload
      );

      expect(commit).toHaveBeenCalledWith(
        MUTATIONS.ON_INFORMACION_ADICIONAL,
        payload
      );
      expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_VALIDAR_RIESGO);
      expect(router.push).toHaveBeenCalledWith("/identidad");
    });

    it("ofertaCajaAhorro - validRisk false → push continuaSucursal sin avanzar", async () => {
      global._BBVA_MOTOR = "ofertaCajaAhorro";
      dispatch.mockResolvedValueOnce(false);

      await actions[ACTIONS.DO_INFORMACION_ADICIONAL](
        { commit, dispatch },
        payload
      );

      expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_VALIDAR_RIESGO);
      expect(router.push).toHaveBeenCalledWith({
        name: "continuaSucursal",
        params: { mensaje: "mensaje-3" }
      });
      expect(router.push).toHaveBeenCalledTimes(1);
    });

    it("ofertaCajaAhorro - validRisk null → despacha DO_MENSAJE con ERROR_TECNICO y continúa al siguiente paso", async () => {
      global._BBVA_MOTOR = "ofertaCajaAhorro";
      dispatch.mockResolvedValueOnce(null);

      await actions[ACTIONS.DO_INFORMACION_ADICIONAL](
        { commit, dispatch },
        payload
      );

      expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_VALIDAR_RIESGO);
      expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      expect(router.push).toHaveBeenCalledWith("/identidad");
    });

    it("ofertaCGU - validRisk true → push al siguiente paso", async () => {
      global._BBVA_MOTOR = "ofertaCGU";
      dispatch.mockResolvedValueOnce(true);

      await actions[ACTIONS.DO_INFORMACION_ADICIONAL](
        { commit, dispatch },
        payload
      );

      expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_VALIDAR_RIESGO);
      expect(router.push).toHaveBeenCalledWith("/identidad");
    });

    it("ofertaCGU - validRisk false → push continuaSucursal", async () => {
      global._BBVA_MOTOR = "ofertaCGU";
      dispatch.mockResolvedValueOnce(false);

      await actions[ACTIONS.DO_INFORMACION_ADICIONAL](
        { commit, dispatch },
        payload
      );

      expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_VALIDAR_RIESGO);
      expect(router.push).toHaveBeenCalledWith({
        name: "continuaSucursal",
        params: { mensaje: "mensaje-3" }
      });
    });

    it("ofertaCGU - validRisk null → despacha DO_MENSAJE con ERROR_TECNICO y continúa al siguiente paso", async () => {
      global._BBVA_MOTOR = "ofertaCGU";
      dispatch.mockResolvedValueOnce(null);

      await actions[ACTIONS.DO_INFORMACION_ADICIONAL](
        { commit, dispatch },
        payload
      );

      expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      expect(router.push).toHaveBeenCalledWith("/identidad");
    });

    it("ofertaNomina - no llama a DO_VALIDAR_RIESGO y push al siguiente paso", async () => {
      global._BBVA_MOTOR = "ofertaNomina";

      await actions[ACTIONS.DO_INFORMACION_ADICIONAL](
        { commit, dispatch },
        payload
      );

      expect(dispatch).not.toHaveBeenCalledWith(ACTIONS.DO_VALIDAR_RIESGO);
      expect(router.push).toHaveBeenCalledWith("/identidad");
    });

    it("sujetoObligado = 1 → continuaSucursal sin llamar a DO_VALIDAR_RIESGO", async () => {
      global._BBVA_MOTOR = "ofertaCajaAhorro";
      const payloadSO = { pep: "0", sujetoObligado: "1", fatca: "0" };

      await actions[ACTIONS.DO_INFORMACION_ADICIONAL](
        { commit, dispatch },
        payloadSO
      );

      expect(router.push).toHaveBeenCalledWith({
        name: "continuaSucursal",
        params: { mensaje: "mensaje-1" }
      });
      expect(dispatch).not.toHaveBeenCalledWith(ACTIONS.DO_VALIDAR_RIESGO);
    });

    it("fatca = 1 → continuaSucursal sin llamar a DO_VALIDAR_RIESGO", async () => {
      global._BBVA_MOTOR = "ofertaCajaAhorro";
      const payloadFatca = { pep: "0", sujetoObligado: "0", fatca: "1" };

      await actions[ACTIONS.DO_INFORMACION_ADICIONAL](
        { commit, dispatch },
        payloadFatca
      );

      expect(router.push).toHaveBeenCalledWith({
        name: "continuaSucursal",
        params: { mensaje: "mensaje-1" }
      });
      expect(dispatch).not.toHaveBeenCalledWith(ACTIONS.DO_VALIDAR_RIESGO);
    });
  });

  describe("DO_VALIDAR_RIESGO", () => {
    it("retorna true cuando status es OK y validRisk es true", async () => {
      om.validarRiesgoCliente.mockResolvedValue({
        data: { status: "OK", respuesta: { validRisk: true } }
      });

      const result = await actions[ACTIONS.DO_VALIDAR_RIESGO]({
        commit,
        getters
      });

      expect(om.validarRiesgoCliente).toHaveBeenCalledWith({
        clientId: expect.anything()
      });
      expect(result).toBe(true);
      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    });

    it("retorna false cuando status es OK pero validRisk es false", async () => {
      om.validarRiesgoCliente.mockResolvedValue({
        data: { status: "OK", respuesta: { validRisk: false } }
      });

      const result = await actions[ACTIONS.DO_VALIDAR_RIESGO]({
        commit,
        getters
      });

      expect(result).toBe(false);
      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    });

    it("retorna false cuando status es ERROR independientemente de validRisk", async () => {
      om.validarRiesgoCliente.mockResolvedValue({
        data: { status: "ERROR", respuesta: { validRisk: true } }
      });

      const result = await actions[ACTIONS.DO_VALIDAR_RIESGO]({
        commit,
        getters
      });

      expect(result).toBe(false);
      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    });

    it("retorna null y loguea error al producirse una excepción", async () => {
      const error = new Error("Error de red");
      om.validarRiesgoCliente.mockRejectedValue(error);

      const result = await actions[ACTIONS.DO_VALIDAR_RIESGO]({
        commit,
        getters
      });

      expect(result).toBeNull();
      expect(Vue.$log.error).toHaveBeenCalledWith(
        "Error en validación de riesgo de cliente",
        error
      );
      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    });

    it("siempre commitea ON_IS_LOADING false en el bloque finally, incluso con error", async () => {
      om.validarRiesgoCliente.mockRejectedValue(new Error("fallo"));

      await actions[ACTIONS.DO_VALIDAR_RIESGO]({ commit, getters });

      const loadingCalls = commit.mock.calls.filter(
        c => c[0] === MUTATIONS.ON_IS_LOADING
      );
      expect(loadingCalls[0]).toEqual([MUTATIONS.ON_IS_LOADING, true]);
      expect(loadingCalls[loadingCalls.length - 1]).toEqual([
        MUTATIONS.ON_IS_LOADING,
        false
      ]);
    });

    it("llama a validarRiesgoCliente con el clientId obtenido del getter getNumeroCliente", async () => {
      om.validarRiesgoCliente.mockResolvedValue({
        data: { status: "OK", respuesta: { validRisk: true } }
      });
      const customGetters = {
        ...getters,
        getNumeroCliente: () => "9988776655"
      };

      await actions[ACTIONS.DO_VALIDAR_RIESGO]({
        commit,
        getters: customGetters
      });

      expect(om.validarRiesgoCliente).toHaveBeenCalledWith({
        clientId: "9988776655"
      });
    });
  });

  it("DO_CLICK_CTA", () => {
    const payload = {};
    actions[ACTIONS.DO_CLICK_CTA]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_CLICK_CTA, {});
  });

  it("DO_VERIDAS_EVENT", () => {
    const payload = {};
    actions[ACTIONS.DO_VERIDAS_EVENT]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_VERIDAS_EVENT, {});
  });

  it("DO_DIGITAL", () => {
    const payload = {};
    actions[ACTIONS.DO_DIGITAL]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_THANKS_VERIDAS, false);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_DIGITAL_PRESENCIAL, {});
  });

  it("getVeridasIframe - success", async () => {
    const context = { commit: jest.fn(), dispatch: jest.fn() };
    const iframeData = { id: "123", urlXpressId: "https://iframe.com" };
    withTsecAuth.mockResolvedValue({ data: { data: iframeData } });

    const result = await actions[ACTIONS.GET_VERIDAS_IFRAME](context);

    expect(withTsecAuth).toHaveBeenCalledWith(ASO.getVeridasIframe);
    expect(context.commit).toHaveBeenCalledWith(
      "SET_DVS_IFRAME_DATA",
      iframeData
    );
    expect(context.dispatch).toHaveBeenCalledWith(
      ACTIONS.DO_ENVIAR_EVENTO_DVS_FS
    );
    expect(result).toEqual(iframeData);
  });

  it("getVeridasIframe logs error and throws error", async () => {
    const context = { commit: jest.fn() };
    const error = new Error("Error getting Veridas iframe");

    withTsecAuth.mockRejectedValue(error);

    await actions[ACTIONS.GET_VERIDAS_IFRAME](context);

    expect(Vue.$log.error).toHaveBeenCalledWith(error);
    expect(context.commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(context.commit).toHaveBeenCalledWith(MUTATIONS.ON_ERROR, error);
  });

  it("DO_SAVE_IFRAME", () => {
    const payload = {};
    actions[ACTIONS.DO_SAVE_IFRAME]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_SAVE_IFRAME, {});
  });

  it("DO_PRELOAD_SDK", () => {
    const payload = {};
    actions[ACTIONS.DO_PRELOAD_SDK]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_PRELOAD_SDK, {});
  });

  it("DO_IS_VISIBLE_SDK", () => {
    const payload = {};
    actions[ACTIONS.DO_IS_VISIBLE_SDK]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_VISIBLE_SDK, {});
  });

  it("DO_POST_VERIDAS_LOGIN", async () => {
    const payload = {};
    om.loginVeridas.mockResolvedValue({
      data: {
        status: "OK",
        respuesta: {}
      }
    });
    agregarACola.mockImplementationOnce(cb => cb());
    await actions[ACTIONS.DO_POST_VERIDAS_LOGIN](
      { commit, getters, dispatch },
      payload
    );

    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_LOGIN, {});
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_POST_FRONT_DNI, {
      resultLogin: {
        data: {
          status: "OK",
          respuesta: {}
        }
      },
      payload: {}
    });
  });

  it("DO_POST_VERIDAS_LOGIN status = Error | intentos permitidos", async () => {
    const payload = {};
    om.loginVeridas.mockResolvedValue({
      data: {
        status: "ERROR",
        respuesta: ["intentos permitidos"]
      }
    });
    agregarACola.mockImplementationOnce(cb => cb().catch(() => {}));
    await actions[ACTIONS.DO_POST_VERIDAS_LOGIN](
      { commit, getters, dispatch },
      payload
    );

    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_ERROR_VERIDAS,
      "error-reintentos-biometria"
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_IS_LOADING, false);
  });

  it("DO_POST_VERIDAS_LOGIN status = Error | sin intentos permitidos", async () => {
    const payload = {};
    om.loginVeridas.mockResolvedValue({
      data: {
        status: "ERROR",
        respuesta: ["sin intentos permitidos"]
      }
    });
    agregarACola.mockImplementationOnce(cb => cb().catch(() => {}));
    await actions[ACTIONS.DO_POST_VERIDAS_LOGIN](
      { commit, getters, dispatch },
      payload
    );

    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_ERROR_VERIDAS,
      "error-servicio-veridas"
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_IS_LOADING, false);
  });

  it("DO_POST_VERIDAS_LOGIN catch Error", async () => {
    const payload = {};
    om.loginVeridas.mockRejectedValue(new Error("Error"));
    agregarACola.mockImplementationOnce(cb => cb().catch(() => {}));
    try {
      await actions[ACTIONS.DO_POST_VERIDAS_LOGIN](
        { commit, getters, dispatch },
        payload
      );
    } catch (error) {
      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_FUNNEL_ERROR, error);
      expect(commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR_VERIDAS,
        "error-servicio-veridas"
      );
    }
  });

  it("DO_POST_FRONT_DNI", async () => {
    const payload = new FormData();
    const resultLogin = {
      data: {
        respuesta: {
          key: "KEY001"
        }
      }
    };
    agregarACola.mockImplementationOnce(cb => cb());
    await actions[ACTIONS.DO_POST_FRONT_DNI](
      { state, dispatch },
      { resultLogin, payload }
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.ENVIO_FRENTE_DNI,
      doSuccess: ACTIONS.DO_ENVIO_FRENTE_DNI_SUCCESS,
      doError: ACTIONS.DO_POST_ERROR,
      payloadSuccess: {
        resolve: expect.any(Function),
        reject: expect.any(Function)
      },
      payloadError: { reject: expect.any(Function) },
      payload: expect.any(FormData)
    });
  });

  it("DO_POST_FRONT_DNI erroVeridas", async () => {
    const payload = new FormData();
    const resultLogin = {
      data: {
        respuesta: {
          key: "KEY001"
        }
      }
    };
    const stateMock = {
      ...state,
      errorVeridas: "error-veridas"
    };
    agregarACola.mockImplementationOnce(cb => cb());
    const dataResponse = await actions[ACTIONS.DO_POST_FRONT_DNI](
      { state: stateMock, dispatch },
      { resultLogin, payload }
    );
    expect(dataResponse).toBe(undefined);
  });

  it("DO_ENVIO_FRENTE_DNI_SUCCESS", () => {
    const payloadSuccess = {
      resolve: jest.fn(),
      reject: jest.fn()
    };
    const respuesta = {
      data: {
        status: "OK"
      }
    };
    actions[ACTIONS.DO_ENVIO_FRENTE_DNI_SUCCESS](
      { commit, dispatch },
      { respuesta, payloadSuccess }
    );
    expect(payloadSuccess.resolve).toHaveBeenCalled();
  });

  it("DO_ENVIO_FRENTE_DNI_SUCCESS reject error-tokenExpired", () => {
    const payloadSuccess = {
      resolve: jest.fn(),
      reject: jest.fn()
    };
    const respuesta = {
      status: "ERROR",
      respuesta: ["La verificaciÃ³n no estÃ¡ abierta"],
      payloadSuccess
    };
    actions[ACTIONS.DO_ENVIO_FRENTE_DNI_SUCCESS](
      { commit, dispatch },
      respuesta
    );
    expect(payloadSuccess.reject).toHaveBeenCalled();
  });

  it("DO_ENVIO_FRENTE_DNI_SUCCESS reject error-dni", () => {
    const payloadSuccess = {
      resolve: jest.fn(),
      reject: jest.fn()
    };
    const respuesta = {
      status: "ERROR",
      respuesta: "",
      payloadSuccess
    };
    actions[ACTIONS.DO_ENVIO_FRENTE_DNI_SUCCESS](
      { commit, dispatch },
      respuesta
    );
    expect(payloadSuccess.reject).toHaveBeenCalled();
  });

  it("DO_POST_REVERSE_DNI", () => {
    const payload = new FormData();
    const stateMock = {
      ...state,
      errorVeridas: ""
    };
    agregarACola.mockImplementationOnce(cb => cb());
    actions[ACTIONS.DO_POST_REVERSE_DNI](
      { state: stateMock, getters, dispatch },
      payload
    );
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.ENVIO_REVERSO_DNI,
      doSuccess: ACTIONS.DO_POST_SUCCESS,
      doError: ACTIONS.DO_POST_ERROR,
      payloadSuccess: {
        resolve: expect.any(Function),
        reject: expect.any(Function)
      },
      payloadError: { reject: expect.any(Function) },
      payload: expect.any(FormData)
    });
  });

  it("DO_POST_REVERSE_DNI errorVeridas", () => {
    const payload = new FormData();
    const stateMock = {
      ...state,
      errorVeridas: "error-veridas"
    };
    agregarACola.mockImplementationOnce(cb => cb());
    const dataResponse = actions[ACTIONS.DO_POST_REVERSE_DNI](
      { state: stateMock, getters, dispatch },
      payload
    );
    expect(dataResponse).toBe(undefined);
  });

  it("DO_POST_SELFIES", async () => {
    const payload = {
      dataSelfie: new FormData(),
      dataSelfieAlive: new FormData()
    };
    agregarACola.mockImplementationOnce(cb => cb());
    await actions[ACTIONS.DO_POST_SELFIES](
      { state, getters, dispatch },
      payload
    );
    expect(dispatch).toHaveBeenCalledTimes(3);
  });

  it("DO_POST_SELFIES errorVeridas", async () => {
    const payload = {
      dataSelfie: new FormData(),
      dataSelfieAlive: new FormData()
    };
    const stateMock = {
      ...state,
      errorVeridas: "error-veridas"
    };
    agregarACola.mockImplementationOnce(cb => cb());
    await actions[ACTIONS.DO_POST_SELFIES](
      { state: stateMock, getters, dispatch },
      payload
    );
    expect(dispatch).not.toHaveBeenCalled();
  });

  it("DO_POST_SUCCESS", () => {
    const payloadSuccess = {
      resolve: jest.fn(),
      reject: jest.fn()
    };
    const respuesta = {
      status: "OK",
      respuesta: "",
      payloadSuccess
    };
    actions[ACTIONS.DO_POST_SUCCESS]({ commit, dispatch }, respuesta);
    expect(payloadSuccess.resolve).toHaveBeenCalled();
  });

  it("DO_POST_SUCCESS status ERROR", () => {
    const payloadSuccess = {
      resolve: jest.fn(),
      reject: jest.fn()
    };
    const respuesta = {
      status: "ERROR",
      respuesta: "",
      payloadSuccess
    };
    actions[ACTIONS.DO_POST_SUCCESS]({ commit, dispatch }, respuesta);
    expect(payloadSuccess.reject).toHaveBeenCalled();
  });

  it("DO_POST_ERROR", () => {
    const payloadError = {
      reject: jest.fn()
    };
    const error = "";
    actions[ACTIONS.DO_POST_ERROR]({ commit }, { error, payloadError });
    expect(payloadError.reject).toHaveBeenCalled();
  });

  it("DO_GET_RESULT", async () => {
    const payload = {
      resolve: jest.fn(),
      reject: jest.fn()
    };
    const strategyMock = jest.fn();
    caminosBiometria.biometriaOk = strategyMock;
    setearCaminosBiometria.mockReturnValue("biometriaOk");
    om.getResultVeridas.mockResolvedValue({
      data: {
        status: "OK",
        respuesta: {
          valid: true,
          puedeReintentar: false
        }
      }
    });
    await actions[ACTIONS.DO_GET_RESULT](
      { commit, getters, dispatch },
      payload
    );
    expect(strategyMock).toHaveBeenCalled();
  });

  it("DO_GET_RESULT status ERROR", async () => {
    const strategyMock = jest.fn();
    caminosBiometria.ERROR = strategyMock;
    setearCaminosBiometria.mockReturnValue("ERROR");
    om.getResultVeridas.mockResolvedValue({
      data: {
        status: "ERROR",
        respuesta: {}
      }
    });
    await actions[ACTIONS.DO_GET_RESULT]({ commit, getters, dispatch });
    expect(strategyMock).toHaveBeenCalled();
  });

  it("DO_GET_RESULT catch ERROR", async () => {
    const payload = {
      resolve: jest.fn(),
      reject: jest.fn()
    };
    om.getResultVeridas.mockRejectedValue(new Error("error-servicio-veridas"));
    try {
      await actions[ACTIONS.DO_GET_RESULT](
        { commit, getters, dispatch },
        payload
      );
    } catch (error) {
      expect(payload.reject).toHaveBeenCalled();
    }
  });

  it("DO_POST_SELFIE", () => {
    const actionMock = jest.spyOn(actions, ACTIONS.DO_POST_SELFIE);
    actions[ACTIONS.DO_POST_SELFIE]();
    expect(actionMock).toHaveBeenCalled();
  });

  it("DO_POST_SELFIE_ALIVE", () => {
    actions[ACTIONS.DO_POST_SELFIE_ALIVE]();
    expect(router.push).toHaveBeenCalledWith("/verificando-biometria");
  });

  it("DO_CONFIGURACION", () => {
    const payload = {};
    actions[ACTIONS.DO_CONFIGURACION](
      { commit, state, getters, dispatch },
      payload
    );
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONFIRMACION,
      doSuccess: ACTIONS.DO_CONFIRMACION_SUCCESS,
      doError: ACTIONS.DO_CONFIRMACION_ERROR,
      payload: {},
      payloadSuccess: {}
    });
  });

  it("DO_CONFIGURACION contratacionFinalizada", () => {
    const payload = {};
    const stateMock = {
      ...state,
      contratacionFinalizada: true
    };
    actions[ACTIONS.DO_CONFIGURACION](
      { commit, state: stateMock, getters, dispatch },
      payload
    );
    expect(router.push).toHaveBeenCalledWith("/contrato");
  });

  it("DO_CONFIRMACION_SUCCESS", () => {
    const payload = {
      status: "OK",
      respuesta: {
        mensaje: "ok",
        nroDeTramite: "1234"
      },
      payloadSuccess: {
        numeroTramite: "123"
      }
    };
    actions[ACTIONS.DO_CONFIRMACION_SUCCESS]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_CONFIGURACION, {
      numeroTramite: "1234"
    });
    expect(router.push).toHaveBeenCalledWith("/contrato");
  });

  it("DO_CONFIRMACION_ERROR", () => {
    const payload = {};
    actions[ACTIONS.DO_CONFIRMACION_ERROR]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_FUNNEL_ERROR, {});
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  });

  it("DO_HUELLA_AVANZADA", () => {
    const payload = {};
    actions[ACTIONS.DO_HUELLA_AVANZADA]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_HUELLA_AVANZADA, payload);
  });

  it("DO_SEARCH_CONTRACT", () => {
    const payload = {};
    actions[ACTIONS.DO_SEARCH_CONTRACT]({ commit, dispatch }, payload);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.GET_CONTRACT,
      doSuccess: ACTIONS.DO_SEARCH_CONTRACT_SUCCESS,
      doError: ACTIONS.DO_SEARCH_CONTRACT_ERROR,
      payloadSuccess: {},
      payload: {}
    });
  });

  it("DO_SEARCH_CONTRACT_SUCCESS", async () => {
    const payload = {
      status: "OK",
      respuesta: {
        contratos: [
          {
            idFormulario: "001",
            claseDocumental: "A",
            idImagen: "ABCDE123456"
          },
          {
            idFormulario: "002",
            claseDocumental: "B",
            idImagen: "ABCDE123456"
          }
        ]
      },
      payloadSuccess: {
        numeroTramite: "123"
      }
    };
    global.URL.createObjectURL = jest.fn(() => "blob:url");
    om.downloadContract.mockResolvedValue({
      data: {
        respuesta: "testPDF"
      }
    });
    await actions[ACTIONS.DO_SEARCH_CONTRACT_SUCCESS]({ commit }, payload);
    await new Promise(resolve => setImmediate(resolve));
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_CONSULTA_CONTRATO, [
      {
        idForm: "001",
        urlPDFBase64: "blob:url"
      },
      {
        idForm: "002",
        urlPDFBase64: "blob:url"
      }
    ]);
  });

  it("DO_SEARCH_CONTRACT_ERROR", () => {
    const payload = {};
    actions[ACTIONS.DO_SEARCH_CONTRACT_ERROR]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_FUNNEL_ERROR, {});
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  });

  it("DO_CONTRATO_PENDING_SIGNATURE", () => {
    const payload = {};
    actions[ACTIONS.DO_CONTRATO_PENDING_SIGNATURE]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_CONTRATO, {});
  });

  it("DO_CONTRATO", () => {
    const payload = {};
    const gettersMock = {
      ...getters,
      getContractsPdf: () => [
        {
          idForm: "T01"
        }
      ]
    };
    actions[ACTIONS.DO_CONTRATO](
      { state, commit, getters: gettersMock, dispatch },
      payload
    );
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(dispatch).toHaveBeenCalled();
  });

  it("DO_CONTRATO contratosFirmados TRUE", () => {
    const payload = {};
    const stateMock = {
      ...state,
      contratosFirmados: true
    };
    actions[ACTIONS.DO_CONTRATO](
      { state: stateMock, commit, getters, dispatch },
      payload
    );
    expect(router.push).toHaveBeenCalledWith({
      name: "mensaje",
      params: {
        mje: "ya-contrato"
      }
    });
  });

  it("DO_CONTRATO_SUCCESS", () => {
    const payload = {
      status: "OK",
      respuesta: {},
      payloadSuccess: {}
    };
    config.pasos = {
      ...config.pasos,
      contrato: {
        pasoSiguiente: "thank"
      },
      thank: {
        path: "/testPath"
      }
    };
    actions[ACTIONS.DO_CONTRATO_SUCCESS]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_CONTRATO, {});
    expect(router.push).toHaveBeenCalledWith("/testPath");
  });

  it("DO_CONTRATO_SUCCESS status ERROR", () => {
    const payload = {
      status: "ERROR",
      respuesta: {}
    };
    actions[ACTIONS.DO_CONTRATO_SUCCESS]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  });

  it("DO_CONTRATO_ERROR", () => {
    const payload = {};
    actions[ACTIONS.DO_CONTRATO_ERROR]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_FUNNEL_ERROR, {});
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  });

  it("SET_ADOBE_TARGET_EXPERIENCE", () => {
    actions[ACTIONS.SET_ADOBE_TARGET_EXPERIENCE]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(
      MUTATIONS.ON_ADOBE_TARGET_EXPERIENCE,
      payload
    );
  });

  it("DO_NORMALIZAR_CELULAR x STATUS !==CO", async () => {
    await actions[ACTIONS.DO_NORMALIZAR_CELULAR]({ commit }, { status: "CA" });
    expect(commit).toHaveBeenCalledWith("ON_NORMALIZAR_CELULAR", {
      valido: false
    });
  });

  it("doNormalizarCelular x STATUS == CO", async () => {
    let payload = {
      status: "CO",
      ddn: 30,
      phoneNumber: "123456",
      characteristic: "011",
      valido: false
    };
    await actions[ACTIONS.DO_NORMALIZAR_CELULAR]({ commit }, payload);
    const bodyExpected = {
      area: "30",
      caracteristica: "011",
      nro: "123456",
      valido: true
    };
    expect(commit).toHaveBeenCalledWith("ON_NORMALIZAR_CELULAR", bodyExpected);
  });
  it("DO_USUARIO_CLAVE", () => {
    const payload = {
      randomKey: "randomKey"
    };
    actions[ACTIONS.DO_USUARIO_CLAVE](
      { state, commit, getters, dispatch },
      payload
    );
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CREAR_USUARIO,
      doSuccess: ACTIONS.DO_USUARIO_CLAVE_SUCCESS,
      doError: ACTIONS.DO_USUARIO_CLAVE_ERROR,
      payload: {
        randomKey: "randomKey"
      }
    });
  });
  it("DO_USUARIO_CLAVE_ERROR", () => {
    const payload = {};
    actions[ACTIONS.DO_USUARIO_CLAVE_ERROR]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_FUNNEL_ERROR, {});
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  });
  it("DO_ENVIO_CELULAR", () => {
    const payload = {};
    actions[ACTIONS.DO_ENVIO_CELULAR](
      { state, commit, getters, dispatch },
      payload
    );
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.GENERAR_OTP,
      doSuccess: ACTIONS.DO_ENVIO_CELULAR_SUCCESS,
      doError: ACTIONS.DO_ENVIO_CELULAR_ERROR,
      payloadSuccess: {},
      payload: {}
    });
  });
  it("DO_ENVIO_CELULAR_SUCCESS", () => {
    const payload = {
      status: "OK",
      respuesta: {
        otp: ""
      },
      payloadSuccess: {
        deviceUdid: ""
      }
    };
    const bodyData = {
      otp: "",
      deviceUdid: ""
    };
    actions[ACTIONS.DO_ENVIO_CELULAR_SUCCESS]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_OTP_ONE, bodyData);
  });
  it("DO_ENVIO_CELULAR_SUCCESS status ERROR", () => {
    const payload = {
      status: "ERROR",
      respuesta: {}
    };
    actions[ACTIONS.DO_ENVIO_CELULAR_SUCCESS]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  });
  it("DO_ENVIO_CELULAR_ERROR", () => {
    const payload = {};
    actions[ACTIONS.DO_ENVIO_CELULAR_ERROR]({ commit, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_FUNNEL_ERROR, {});
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_MENSAJE, ERROR_CONEXION);
  });
  it("DO_CELULAR", () => {
    const payload = {
      otp: ""
    };
    actions[ACTIONS.DO_CELULAR]({ state, commit, getters, dispatch }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, true);
    expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.VALIDAR_OTP,
      doSuccess: ACTIONS.DO_CELULAR_SUCCESS,
      doError: ACTIONS.DO_CELULAR_ERROR,
      payloadSuccess: payload,
      payload: {
        deviceUdid: "",
        otp: ""
      }
    });
  });
  it("DO_CELULAR_SUCCESS", () => {
    const payload = {
      status: "OK",
      respuesta: {
        valid: true
      },
      payloadSuccess: {}
    };
    actions[ACTIONS.DO_CELULAR_SUCCESS]({ getters, commit, dispatch }, payload);
    expect(router.push).toHaveBeenCalledWith("/usuario-y-clave");
  });
  it("DO_CELULAR_SUCCESS status ERROR", () => {
    const payload = {
      status: "ERROR",
      respuesta: {}
    };
    actions[ACTIONS.DO_CELULAR_SUCCESS]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_OTP_ERROR);
  });
  it("DO_CELULAR_ERROR", () => {
    const payload = {};
    actions[ACTIONS.DO_CELULAR_ERROR]({ commit }, payload);
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_FUNNEL_ERROR, {});
    expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_OTP_ERROR);
  });

  describe("DO_NORMALIZAR_NUMERO", () => {
    it("DO_NORMALIZAR_NUMERO X DO_REQUEST_API", () => {
      actions[ACTIONS.DO_NORMALIZAR_NUMERO]({ commit, dispatch }, payload);

      expect(dispatch).toHaveBeenCalledWith(ACTIONS.DO_REQUEST_API, {
        endPoint: END_POINTS.NORMALIZAR_NUMERO,
        doSuccess: ACTIONS.DO_NORMALIZAR_NUMERO_SUCCESS,
        doError: ACTIONS.DO_NORMALIZAR_NUMERO_ERROR,
        payload: {
          level1: "AR",
          level2: "",
          level3: "",
          level4: "",
          level5: "",
          phoneNumber: payload,
          characteristic: "",
          postalCode: "",
          prefix: "",
          additionalData: ""
        }
      });
    });

    it("DO_NORMALIZAR_NUMERO_SUCCESS", () => {
      const response = {
        respuesta: "PRUEBA_TEST"
      };
      actions[ACTIONS.DO_NORMALIZAR_NUMERO_SUCCESS](
        { commit, dispatch },
        response
      );
      expect(dispatch).toHaveBeenCalledWith(
        "DO_NORMALIZAR_CELULAR",
        "PRUEBA_TEST"
      );
    });

    it("DO_NORMALIZAR_NUMERO_ERROR", () => {
      actions[ACTIONS.DO_NORMALIZAR_NUMERO_ERROR](
        { commit, dispatch },
        payload
      );
      expect(Vue.$log.error).toHaveBeenCalledWith(payload);
    });
  });

  describe("Actions test para ACTIONS.DO_DATA_AUTH_ASO", () => {
    const context = {
      commit: jest.fn()
    };

    beforeEach(() => {
      jest.clearAllMocks();
    });

    it("debería llamar a la mutación ON_DATA_AUTH_ASO con el payload correcto", () => {
      const payload = { key: "value" };
      actions[ACTIONS.DO_DATA_AUTH_ASO](context, payload);

      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_DATA_AUTH_ASO,
        payload
      );
    });
  });

  describe("ACTIONS.GET_REINTENTOS_BIO", () => {
    const om = require("@/api/index");
    const context = {
      getters: {
        getConsulta: jest.fn(() => ({ numeroDoc: "12345678" }))
      },
      commit: jest.fn()
    };

    beforeEach(() => {
      jest.clearAllMocks();
    });

    it("debería retornar true si respuesta es true y status OK", async () => {
      om.consultarReintentosBio = jest.fn().mockResolvedValue({
        data: { status: "OK", respuesta: true }
      });

      const result = await actions[ACTIONS.GET_REINTENTOS_BIO](context);
      expect(om.consultarReintentosBio).toHaveBeenCalledWith("12345678");
      expect(result).toBe(true);
    });

    it("debería retornar false si status es ERROR", async () => {
      om.consultarReintentosBio = jest.fn().mockResolvedValue({
        data: { status: "ERROR" }
      });

      const result = await actions[ACTIONS.GET_REINTENTOS_BIO](context);
      expect(result).toBe(false);
      expect(require("@/router").push).toHaveBeenCalledWith({
        name: "mensajeVeridas",
        params: { mje: "error-servidor" }
      });
    });

    it("debería retornar false si respuesta es false y status OK", async () => {
      om.consultarReintentosBio = jest.fn().mockResolvedValue({
        data: { status: "OK", respuesta: false }
      });

      const result = await actions[ACTIONS.GET_REINTENTOS_BIO](context);
      expect(result).toBe(false);
      expect(require("@/router").push).toHaveBeenCalledWith({
        name: "mensajeVeridas",
        params: { mje: "error-veridas-ca" }
      });
    });

    it("debería manejar errores de red o excepciones", async () => {
      const mockedError = new Error("Error de red");
      om.consultarReintentosBio = jest.fn().mockResolvedValue(mockedError);

      await actions[ACTIONS.GET_REINTENTOS_BIO](context);

      expect(require("@/router").push).toHaveBeenCalledWith({
        name: "mensajeVeridas",
        params: { mje: "error-servidor" }
      });
    });
  });

  describe("ACTIONS.GET_VERIDAS_IFRAME", () => {
    const commit = jest.fn();
    const dispatch = jest.fn();
    const context = { commit, dispatch };

    beforeEach(() => {
      jest.clearAllMocks();
    });

    it("debería setear el iframe si la respuesta es válida", async () => {
      const mockedResponse = {
        data: { data: { id: "iframe-id", urlXpressId: "https://iframe.com" } }
      };
      withTsecAuth.mockResolvedValue(mockedResponse);

      const result = await actions[ACTIONS.GET_VERIDAS_IFRAME](context);

      expect(withTsecAuth).toHaveBeenCalled();
      expect(commit).toHaveBeenCalledWith(
        MUTATIONS.SET_DVS_IFRAME_DATA,
        mockedResponse.data.data
      );
      expect(result).toEqual(mockedResponse.data.data);
    });

    it("debería manejar error si los datos del iframe son incompletos", async () => {
      dispatch.mockResolvedValueOnce(true);
      const mockedResponse = { data: { data: {} } };
      withTsecAuth.mockResolvedValue(mockedResponse);

      await actions[ACTIONS.GET_VERIDAS_IFRAME](context);

      expect(commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR,
        "Error: La respuesta no contiene los datos del iframe."
      );
      expect(require("@/router").push).toHaveBeenCalledWith({
        name: "mensajeVeridas",
        params: { mje: "error-servicio-veridas" }
      });
    });

    it("debería manejar errores de red o excepciones", async () => {
      dispatch.mockResolvedValueOnce(true);
      const mockedError = new Error("Error de red");
      withTsecAuth.mockRejectedValue(mockedError);

      await actions[ACTIONS.GET_VERIDAS_IFRAME](context);

      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_IS_LOADING,
        false
      );
      expect(require("@/router").push).toHaveBeenCalledWith({
        name: "mensajeVeridas",
        params: { mje: "error-servicio-aso" }
      });
    });

    it("debería manejar error 500 del servidor y NO montar el iframe", async () => {
      dispatch.mockResolvedValueOnce(true);
      const serverError = new Error(
        "Error en el servidor al obtener TSEC: 500 - Internal Server Error"
      );
      withTsecAuth.mockRejectedValue(serverError);

      await actions[ACTIONS.GET_VERIDAS_IFRAME](context);

      expect(commit).not.toHaveBeenCalledWith(
        MUTATIONS.SET_DVS_IFRAME_DATA,
        expect.anything()
      );
      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_ERROR, serverError);
      expect(require("@/router").push).toHaveBeenCalledWith({
        name: "mensajeVeridas",
        params: { mje: "error-servicio-aso" }
      });
    });

    it("debería manejar error 400 del servidor y NO montar el iframe", async () => {
      dispatch.mockResolvedValueOnce(true);
      const badRequestError = new Error(
        "Error en el servidor al obtener TSEC: 400 - Bad Request"
      );
      withTsecAuth.mockRejectedValue(badRequestError);

      await actions[ACTIONS.GET_VERIDAS_IFRAME](context);

      expect(commit).not.toHaveBeenCalledWith(
        MUTATIONS.SET_DVS_IFRAME_DATA,
        expect.anything()
      );
      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_IS_LOADING, false);
      expect(commit).toHaveBeenCalledWith(MUTATIONS.ON_ERROR, badRequestError);
      expect(require("@/router").push).toHaveBeenCalledWith({
        name: "mensajeVeridas",
        params: { mje: "error-servicio-aso" }
      });
    });
  });

  describe("Actions test para ACTIONS.GET_VERIDAS_RESULT", () => {
    const context = {
      getters: {
        getVeridasId: mock.getters.getVeridasId
      },
      commit: jest.fn(),
      dispatch: jest.fn()
    };

    beforeEach(() => {
      jest.clearAllMocks();
    });

    it("debería manejar el estado PENDING y volver a llamar a ACTIONS.GET_VERIDAS_RESULT después de 3 segundos. incrementa contador", async () => {
      jest.useFakeTimers();
      const mockedResponse = { data: { data: { result: "PENDING" } } };
      withTsecAuth.mockResolvedValue(mockedResponse);

      await actions[ACTIONS.GET_VERIDAS_RESULT](context, 0);

      // setTimeout se llamó
      expect(setTimeout).toHaveBeenCalledWith(expect.any(Function), 3000);

      // Capturamos la función pasada a setTimeout
      const timeoutCallback = setTimeout.mock.calls[0][0];

      // Ejecutamos manualmente la función simulando el tiempo transcurrido
      timeoutCallback();

      // Ahora sí, validamos que el dispatch fue llamado correctamente
      expect(context.dispatch).toHaveBeenCalledWith(
        ACTIONS.GET_VERIDAS_RESULT,
        1
      );
    });

    it("debe cortar el flujo y mostrar error si supera el límite de reintentos en GET_VERIDAS_RESULT", async () => {
      const mockedResponse = { data: { data: { result: "PENDING" } } };
      withTsecAuth.mockResolvedValue(mockedResponse);

      await actions[ACTIONS.GET_VERIDAS_RESULT](context, 12);

      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_IS_LOADING,
        false
      );
      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR,
        expect.any(String)
      );
      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR_VERIDAS,
        "error-servicio-veridas"
      );
      expect(context.dispatch).not.toHaveBeenCalledWith(
        ACTIONS.GET_VERIDAS_RESULT,
        13
      );
    });

    it("debería llamar GET_RENAPER_VALIDATION si el resultado es OK", async () => {
      const mockedResponse = { data: { data: { result: "OK" } } };
      withTsecAuth.mockResolvedValue(mockedResponse);

      await actions[ACTIONS.GET_VERIDAS_RESULT](context);

      expect(context.dispatch).toHaveBeenCalledWith(
        ACTIONS.GET_RENAPER_VALIDATION
      );
    });

    it("debería llamar GET_RENAPER_VALIDATION si el resultado es KO", async () => {
      const mockedResponse = { data: { data: { result: "KO" } } };
      withTsecAuth.mockResolvedValue(mockedResponse);

      await actions[ACTIONS.GET_VERIDAS_RESULT](context);

      expect(context.dispatch).toHaveBeenCalledWith(
        ACTIONS.GET_RENAPER_VALIDATION
      );
    });

    it("debería manejar errores si el resultado no es OK ni KO", async () => {
      const mockedResponse = { data: { data: { result: "ERROR" } } };
      withTsecAuth.mockResolvedValue(mockedResponse);

      await actions[ACTIONS.GET_VERIDAS_RESULT](context);

      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_IS_LOADING,
        false
      );
      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR_VERIDAS,
        "error-servicio-veridas"
      );
    });

    it("debería manejar errores de red o excepciones", async () => {
      const mockedError = new Error("Error de red");
      withTsecAuth.mockRejectedValue(mockedError);

      await actions[ACTIONS.GET_VERIDAS_RESULT](context);

      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_IS_LOADING,
        false
      );
      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR_VERIDAS,
        "error-servicio-aso"
      );
    });
  });

  describe("Actions test para ACTIONS.GET_RENAPER_VALIDATION", () => {
    const context = {
      getters: {
        getVeridasId: mock.getters.getVeridasId,
        getOferta: jest.fn(() => ({ nroDeTramite: "tramite-id" })),
        getCircuito: jest.fn(() => "tvos")
      },
      commit: jest.fn(),
      dispatch: jest.fn()
    };

    beforeEach(() => {
      jest.clearAllMocks();
    });

    it("debería manejar el estado PENDING y volver a llamar a ACTIONS.GET_RENAPER_VALIDATION después de 3 segundos, incrementa contador", async () => {
      jest.useFakeTimers();
      const mockedResponse = {
        data: {
          data: { result: "PENDING" }
        }
      };
      retry.mockResolvedValue([null, mockedResponse]);

      await actions[ACTIONS.GET_RENAPER_VALIDATION](context, 0);

      expect(retry).toHaveBeenCalledWith(expect.any(Function), 3000, 5);
      expect(setTimeout).toHaveBeenCalledWith(expect.any(Function), 3000);

      jest.runAllTimers();
      expect(context.dispatch).toHaveBeenCalledWith(
        ACTIONS.GET_RENAPER_VALIDATION,
        1
      );
    });

    it("debe cortar el flujo y mostrar error si supera el límite de reintentos en GET_RENAPER_VALIDATION", async () => {
      const mockedResponse = { data: { data: { result: "PENDING" } } };
      require("@/api/aso").withTsecAuth.mockResolvedValue(mockedResponse);

      await actions[ACTIONS.GET_RENAPER_VALIDATION](context, 12);

      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_IS_LOADING,
        false
      );
      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR,
        expect.any(String)
      );
      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR_VERIDAS,
        "error-servicio-veridas"
      );
      expect(context.dispatch).not.toHaveBeenCalledWith(
        ACTIONS.GET_RENAPER_VALIDATION,
        13
      );
    });
    it("debería llamar DO_ENVIAR_RESULTADOS_BIOMETRIA si el resultado es FINISHED y enviar el resultado como parametro", async () => {
      const mockedResponse = {
        data: {
          data: {
            result: "FINISHED",
            message: {
              dataOcrDesc: [],
              renaper2Desc: { validationResult: "OK" },
              renaper3Desc: { validationResult: "OK" },
              dvsStatusType: "OK"
            }
          }
        }
      };
      retry.mockResolvedValue([null, mockedResponse]);

      await actions[ACTIONS.GET_RENAPER_VALIDATION](context);

      expect(context.dispatch).toHaveBeenCalledWith(
        ACTIONS.DO_ENVIAR_RESULTADOS_BIOMETRIA,
        mockedResponse.data.data
      );
    });

    it("debería manejar errores si el estado no es FINISHED", async () => {
      const mockedResponse = {
        data: {
          data: {
            message: { infoStatusType: "ERROR" }
          }
        }
      };
      retry.mockResolvedValue([null, mockedResponse]);

      await actions[ACTIONS.GET_RENAPER_VALIDATION](context);

      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR,
        "Error: falla resultados validacion."
      );
      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR_VERIDAS,
        "error-servicio-renaper"
      );
    });
    it("debería manejar errores de red o excepciones", async () => {
      const mockedError = new Error("Error genérico");
      retry.mockRejectedValue([mockedError, null]);

      await actions[ACTIONS.GET_RENAPER_VALIDATION](context);

      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_IS_LOADING,
        false
      );
      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR_VERIDAS,
        "error-servicio-aso"
      );
    });
  });

  describe("ACTIONS.DO_ENVIAR_RESULTADOS_BIOMETRIA", () => {
    const om = require("@/api/index");
    const commit = jest.fn();
    const getters = {
      getOferta: () => ({ nroDeTramite: "123" }),
      getConsulta: () => ({ numeroDoc: "321" }),
      getDeviceId: () => "aaaaa-aaaa-aaaa-aaaa-aaaaaa",
      getDeviceIdTimestamp: () => "2025-07-18T17:11:00-0300",
      getTCode: () => "Personales",
      getVeridasId: mock.getters.getVeridasId
    };
    const context = { commit, getters };

    beforeEach(() => {
      jest.clearAllMocks();
    });

    it("debería navegar al siguiente paso si todos los resultados son OK", async () => {
      global._BBVA_MOTOR = "ofertaCajaAhorro";

      const payload = {
        id: "bio-id",
        message: {
          dvsStatusType: "OK",
          renaper3Desc: { validationResult: "OK" },
          renaper2Desc: { validationResult: "OK" }
        },
        messages: { dataOcrDesc: [] }
      };
      om.enviarResultadosBiometria = jest.fn().mockResolvedValue({
        data: {
          respuesta: {
            valid: true,
            puedeReintentar: true
          }
        }
      });

      await actions[ACTIONS.DO_ENVIAR_RESULTADOS_BIOMETRIA](context, payload);

      expect(om.enviarResultadosBiometria).toHaveBeenCalled();
      expect(require("@/router").replace).toHaveBeenCalledWith("/biometria-ok");
      expect(commit).not.toHaveBeenCalled();
    });

    it("debería commitear error-veridas-result si puede reintentar", async () => {
      const payload = {
        id: "bio-id",
        message: {
          dvsStatusType: "KO",
          renaper3Desc: { validationResult: "OK" },
          renaper2Desc: { validationResult: "OK" }
        },
        messages: { dataOcrDesc: [] }
      };
      om.enviarResultadosBiometria = jest.fn().mockResolvedValue({
        data: {
          respuesta: {
            valid: false,
            puedeReintentar: true
          }
        }
      });

      await actions[ACTIONS.DO_ENVIAR_RESULTADOS_BIOMETRIA](context, payload);

      expect(om.enviarResultadosBiometria).toHaveBeenCalled();
      expect(commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR_VERIDAS,
        "error-veridas-result"
      );
      expect(require("@/router").replace).not.toHaveBeenCalled();
    });

    it("debería commitear error-reintentos-biometria si NO puede reintentar", async () => {
      const payload = {
        id: "bio-id",
        message: {
          dvsStatusType: "KO",
          renaper3Desc: { validationResult: "KO" },
          renaper2Desc: { validationResult: "OK" }
        },
        messages: { dataOcrDesc: [] }
      };
      om.enviarResultadosBiometria = jest.fn().mockResolvedValue({
        data: {
          respuesta: {
            valid: false,
            puedeReintentar: false
          }
        }
      });

      await actions[ACTIONS.DO_ENVIAR_RESULTADOS_BIOMETRIA](context, payload);

      expect(om.enviarResultadosBiometria).toHaveBeenCalled();
      expect(commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR_VERIDAS,
        "error-veridas-ca"
      );
      expect(require("@/router").replace).not.toHaveBeenCalled();
    });

    it("debería manejar errores de red o excepciones", async () => {
      const payload = {
        id: "bio-id",
        message: {
          dvsStatusType: "KO",
          renaper3Desc: { validationResult: "KO" },
          renaper2Desc: { validationResult: "OK" }
        },
        messages: { dataOcrDesc: [] }
      };
      const mockedError = new Error("Error genérico");
      om.enviarResultadosBiometria = jest.fn().mockRejectedValue(mockedError);

      await actions[ACTIONS.DO_ENVIAR_RESULTADOS_BIOMETRIA](context, payload);

      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_IS_LOADING,
        false
      );
      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR_VERIDAS,
        "error-servicio-aso"
      );
    });
  });

  describe("ACTIONS.DO_ENVIAR_EVENTO_DVS_FS", () => {
    const om = require("@/api/index");
    it("debería llamar om.enviarEventoDvsFS con el payload correcto", async () => {
      om.enviarEventoDvsFS = jest.fn().mockResolvedValue({});

      global._BBVA_MOTOR = "ofertaCajaAhorro";

      const context = {
        getters: {
          getConsulta: jest.fn(() => ({
            numeroDoc: "30123456",
            tipoDoc: "00",
            numeroCliente: "30123456"
          })),
          getCircuito: jest.fn(() => "ofertaCajaAhorro"),
          getDeviceId: jest.fn(() => "3d2cc10c-0a92-4faa-b753-342beb49347l"),
          getDeviceIdTimestamp: jest.fn(() => "2025-07-18T17:11:00-0300"),
          getTCode: jest.fn(() => ""),
          getVeridasId: mock.getters.getVeridasId
        },
        commit: jest.fn()
      };

      await actions[ACTIONS.DO_ENVIAR_EVENTO_DVS_FS](context);

      expect(om.enviarEventoDvsFS).toHaveBeenCalledWith({
        nroDoc: "30123456",
        c: "ofertaCajaAhorro",
        tipoDocumento: "00",
        deviceId: "3d2cc10c-0a92-4faa-b753-342beb49347l",
        deviceIdTimestamp: "2025-07-18T17:11:00-0300",
        numeroCliente: "30123456",
        idBiometria: "dvs-id"
      });
    });

    it("debería manejar errores y commitear ON_ERROR", async () => {
      om.enviarEventoDvsFS = jest
        .fn()
        .mockRejectedValue(new Error("Error de red"));

      const context = {
        getters: {
          getConsulta: jest.fn(() => ({
            numeroDoc: "30123456",
            tipoDocumento: "00",
            numeroCliente: "12345678"
          })),
          getCircuito: jest.fn(() => "ofertaCajaAhorro"),
          getDeviceId: jest.fn(() => "3d2cc10c-0a92-4faa-b753-342beb49347l"),
          getDeviceIdTimestamp: jest.fn(() => "2025-07-18T17:11:00-0300"),
          getVeridasId: mock.getters.getVeridasId
        },
        commit: jest.fn()
      };

      await actions[ACTIONS.DO_ENVIAR_EVENTO_DVS_FS](context);

      expect(context.commit).toHaveBeenCalledWith(
        MUTATIONS.ON_ERROR,
        expect.any(Error)
      );
    });
  });
});
